<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>申報年度</td>
                  <td>
                    <select v-model="form.syear">
                      <option v-for="(data, index) in dropDownList.syears" :key="index" :value="data">
                        {{ data }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關</td>
                  <td colspan="3">
                    <select v-model="form.jobGovCode1" style="min-width: 200px" @change="JobGovCode1Change()" :disabled="loginInfo &&
      loginInfo.roleSeq != 1 &&
      1 <= loginInfo.layerNum
      ">
                      <option v-for="(item, index) in dropDownList.jobGovCode1s" :value="item.value" :key="index">
                        {{ item.text }}
                      </option>
                    </select>
                    <select v-model="form.jobGovCode2" style="min-width: 200px" @change="JobGovCode2Change()" :disabled="loginInfo &&
      loginInfo.roleSeq != 1 &&
      2 <= loginInfo.layerNum
      ">
                      <option v-for="(item, index) in dropDownList.jobGovCode2s" :value="item.value" :key="index">
                        {{ item.text }}
                      </option>
                    </select>
                    <select v-model="form.jobGovCode3" style="min-width: 200px" @change="JobGovCode3Change()" :disabled="loginInfo &&
      loginInfo.roleSeq != 1 &&
      3 <= loginInfo.layerNum
      ">
                      <option v-for="(item, index) in dropDownList.jobGovCode3s" :value="item.value" :key="index">
                        {{ item.text }}
                      </option>
                    </select>
                    <select v-model="form.jobGovCode4" style="min-width: 200px" :disabled="loginInfo &&
      loginInfo.roleSeq != 1 &&
      4 <= loginInfo.layerNum
      ">
                      <option v-for="(item, index) in dropDownList.jobGovCode4s" :value="item.value" :key="index">
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input type="checkbox" v-model="form.jobGovCheck" true-value="1" false-value="0" />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號</td>
                  <td>
                    <input type="text" v-model="form.idn" />
                  </td>
                  <td>姓名</td>
                  <td>
                    <input type="text" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td>輸出格式</td>
                  <td colspan="3">
                    <p>
                      <label>
                        <input type="radio" v-model="form.printtype" value="DOCX" checked="checked" />
                        DOCX</label>
                      <label>
                        <input type="radio" v-model="form.printtype" value="ODT" checked="checked" />
                        ODT</label>
                      <!--<label>
                        <input
                          type="radio"
                          v-model="form.printtype"
                          value="PDF"
                        />
                        PDF</label
                      >-->
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"><span>
                        <input type="submit" class="btn" value="查詢" @click="() => {
      this.form.currentpage = 1;
      this.doQuery();
    }
      " />
                        <input type="submit" class="btn" value="重填" @click="btnClear()" /> </span></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%" v-if="grid && grid.gridDatas && grid.gridDatas.length > 0">
            <tbody>
              <tr v-if="grid.paginaiton">
                <td align="right">
                  <input type="button" value="<<" class="btn" style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1" v-show="grid.paginaiton.pageNo > 1" />
                  <span v-for="(data, index) in grid.paginaiton.pages" :key="index" style="cursor: pointer" :style="grid.paginaiton.pageNo == data
      ? 'color:red'
      : 'color:black'
      " @click="form.currentpage = parseInt(data)">
                    {{
      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
    }}
                  </span>
                  <input type="button" class="btn" value=">>" style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1" />
                  ［每頁<input type="text" v-model.number.lazy="form.pagesize" size="2" />

                  <input type="button" class="btn" value="筆" />，第<input type="text"
                    v-model.number.lazy="form.currentpage" size="2" />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th colspan="2">操作</th>
                    <th>
                      <u style="cursor: pointer" target="_blank" @click="() => {
      this.reQuery('DTYPE', Sort);
    }
      ">申報種類</u>
                    </th>
                    <th>
                      <u style="cursor: pointer" target="_blank" @click="() => {
      this.reQuery('NAME', Sort);
    }
      ">姓名</u>
                    </th>
                    <th>
                      <u style="cursor: pointer" target="_blank" @click="() => {
      this.reQuery('IDN', Sort);
    }
      ">身分證統一編號</u>
                    </th>
                    <th>
                      <u style="cursor: pointer" target="_blank" @click="() => {
      this.reQuery('GOV_CODE', Sort);
    }
      ">服務機關</u>
                    </th>
                    <th>
                      <u style="cursor: pointer" target="_blank" @click="() => {
      this.reQuery('job_gov_code', Sort);
    }
      ">受理申報機關</u>
                    </th>
                    <th>
                      <u style="cursor: pointer" target="_blank" @click="() => {
      this.reQuery('SDATE', Sort);
    }
      ">申報基準日</u>
                    </th>
                    <th>
                      <u style="cursor: pointer" target="_blank" @click="() => {
      this.reQuery('DATETIME', Sort);
    }
      ">上傳日期</u>
                    </th>
                    <th>
                      <u style="cursor: pointer" target="_blank" @click="() => {
      this.reQuery('SurveyDay', Sort);
    }
      ">財產查調日</u>
                    </th>
                  </tr>
                </thead>
                <tbody v-if="grid && grid.gridDatas && grid.gridDatas.length > 0">
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input type="button" class="btn" value="審核" :disabled="!data.btnCheckFlag"
                        @click="btnModalShow(data)" />
                    </td>
                    <td width="1%" align="center">
                      <input type="button" class="btn" value="列印" :disabled="!data.btnCheckFlag || !data.btnPrintFlag"
                        @click="btnPrint(data)" />
                    </td>
                    <td>{{ data.dtype }}</td>
                    <td>{{ data.name }}</td>
                    <td>
                      <input type="button" class="btn" :value="data.idn" @click="btnA101Detail(data)" />
                    </td>
                    <td>{{ data.goV_CODE_STR }}</td>
                    <td>{{ data.goV_NAME }}</td>
                    <td>{{ data.sdate }}</td>
                    <td>{{ data.datetimestr }}</td>
                    <td>{{ data.surveyDayStr }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="9" style="text-align: center">查無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />

    <!-- 審核 -->
    <DetailModal v-model="DetailModal.show" :title="DetailModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td class="col-3">申報人</td>
                <td class="col-3">{{ DetailModal.form.name }}</td>
                <td class="col-3">身分證統一編號</td>
                <td class="col-3">{{ DetailModal.form.idn }}</td>
              </tr>
              <tr>
                <td class="col-3">申報種類</td>
                <td class="col-3">{{ DetailModal.form.dtype }}</td>
                <td class="col-3">申報基準日</td>
                <td class="col-3">{{ DetailModal.form.sdate }}</td>
              </tr>
              <tr>
                <td class="col-3">上傳日期</td>
                <td class="col-3">{{ DetailModal.form.datetime }}</td>
                <td class="col-3"></td>
                <td class="col-3"></td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="列印不符項目" @click="DetailModalBtnPrintCKA()" />
                      <input type="button" class="btn" value="列印" @click="DetailModalBtnPrint()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
      <div class="information">
        <table width="100%">
          <tbody>
            <tr v-if="DetailModal.grid.paginaiton">
              <td align="right">
                <input type="button" value="<<" class="btn" style="height: 28px" @click="
      DetailModal.currentpage =
      DetailModal.grid.paginaiton.pageNo - 1
      " v-show="DetailModal.grid.paginaiton.pageNo > 1" />
                <span v-for="(data, index) in DetailModal.grid.paginaiton.pages" :key="index" style="cursor: pointer"
                  :style="DetailModal.grid.paginaiton.pageNo == data
      ? 'color:red'
      : 'color:black'
      " @click="DetailModal.currentpage = parseInt(data)">
                  {{
      DetailModal.grid.paginaiton.pageNo == data
        ? "[" + data + "]"
        : data
    }}
                </span>
                <input type="button" class="btn" value=">>" style="height: 28px" v-show="DetailModal.grid.paginaiton.pageNo <
      DetailModal.grid.paginaiton.totalPage
      " @click="
      DetailModal.currentpage =
      DetailModal.grid.paginaiton.pageNo + 1
      " />
                ［每頁<input type="text" v-model.number.lazy="DetailModal.pagesize" size="2" maxlength="4" />

                <input type="button" class="btn" value="筆" />，第<input type="text"
                  v-model.number.lazy="DetailModal.currentpage" size="2" maxlength="4" />
                <input type="button" class="btn" value="頁" />，共
                {{ DetailModal.grid.paginaiton.totalPage }} 頁
                {{ DetailModal.grid.paginaiton.totalCount }} 筆］
              </td>
            </tr>
            <tr>
              <td>
                <ul>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 0;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Land');
    " :style="{
      color: DetailModal.MenuIndex == 0 ? '#F00' : '#000',
    }">土地</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 1;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Building');
    " :style="{
      color: DetailModal.MenuIndex == 1 ? '#F00' : '#000',
    }">建物</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 2;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Vessel');
    " :style="{
      color: DetailModal.MenuIndex == 2 ? '#F00' : '#000',
    }">船舶</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 3;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Vehicle');
    " :style="{
      color: DetailModal.MenuIndex == 3 ? '#F00' : '#000',
    }">汽車</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 4;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Aircraft');
    " :style="{
      color: DetailModal.MenuIndex == 4 ? '#F00' : '#000',
    }">航空器</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 5
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('FCurrency');
    " :style="{
      color: DetailModal.MenuIndex == 5 ? '#F00' : '#000',
    }">現金</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 6;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Deposit');
    " :style="{
      color: DetailModal.MenuIndex == 6 ? '#F00' : '#000',
    }">存款</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 7;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('StocknBond_1');
    " :style="{
      color: DetailModal.MenuIndex == 7 ? '#F00' : '#000',
    }">有價證券(股票)</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 8;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('StocknBond_2');
    " :style="{
      color: DetailModal.MenuIndex == 8 ? '#F00' : '#000',
    }">有價證券(票券，債券，其他有價證券)</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 9;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('StocknBond_3');
    " :style="{
      color: DetailModal.MenuIndex == 9 ? '#F00' : '#000',
    }">有價證券(基金受益憑證)</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 10;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Misc');
    " :style="{
      color: DetailModal.MenuIndex == 10 ? '#F00' : '#000',
    }">其他財產</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 11;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Insurance');
    " :style="{
      color: DetailModal.MenuIndex == 11 ? '#F00' : '#000',
    }">保險</a>
                  </li>
                  <li class="TabbedPanelsTab" v-show="DetailModal.showVirtualAssets">
                    <a @click="
      DetailModal.MenuIndex = 16;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('VirtualAssets');
    " :style="{
      color: DetailModal.MenuIndex == 16 ? '#F00' : '#000',
    }">虛擬資產</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 12;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Credit');
    " :style="{
      color: DetailModal.MenuIndex == 12 ? '#F00' : '#000',
    }">債權</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 13;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Debit');
    " :style="{
      color: DetailModal.MenuIndex == 13 ? '#F00' : '#000',
    }">債務</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 14;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Investment');
    " :style="{
      color: DetailModal.MenuIndex == 14 ? '#F00' : '#000',
    }">事業投資</a>
                  </li>
                  <li class="TabbedPanelsTab">
                    <a @click="
      DetailModal.MenuIndex = 15;
    DetailModal.pagesize = 20;
    DetailModal.currentpage = 1;
    F201_SearchGrid2('Building');
    " :style="{
      color: DetailModal.MenuIndex == 15 ? '#F00' : '#000',
    }">備註</a>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <input type="button" class="btn" value="新增查核資料" v-show="!(
      DetailModal.MenuIndex == '15'
    )
      " @click="DetailModalbtnAdd()" />
                <input type="button" class="btn" value="回溯原查核資料" v-show="!(
      DetailModal.MenuIndex == '15'
    )
      " @click="DetailModalbtnRe(DetailModal.MenuIndex)" />
                <input type="button" class="btn" value="存檔" v-show="!(
      DetailModal.MenuIndex == '15'
    )
      " @click="DetailModalbtnSave()" />
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 查詢結果開始-->
        <!-- 土地 -->
        <div v-show="DetailModal.MenuIndex === 0" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Lands && DetailModal.form.Lands.length">
                <tr v-for="(data, index) in DetailModal.form.Lands" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td>
                    {{ data.mainResult }}
                  </td>
                  <td>
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 建物 -->
        <div v-show="DetailModal.MenuIndex === 1" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Buildings &&
      DetailModal.form.Buildings.length
      ">
                <tr v-for="(data, index) in DetailModal.form.Buildings" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td>
                    {{ data.mainResult }}
                  </td>
                  <td>
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 船舶 -->
        <div v-show="DetailModal.MenuIndex === 2" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Vessels && DetailModal.form.Vessels.length
      ">
                <tr v-for="(data, index) in DetailModal.form.Vessels" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td>
                    {{ data.mainResult }}
                  </td>
                  <td>
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 汽車 -->
        <div v-show="DetailModal.MenuIndex === 3" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Vehicles && DetailModal.form.Vehicles.length
      ">
                <tr v-for="(data, index) in DetailModal.form.Vehicles" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td>
                    {{ data.mainResult }}
                  </td>
                  <td>
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 航空器 -->
        <div v-show="DetailModal.MenuIndex === 4" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Aircrafts &&
      DetailModal.form.Aircrafts.length
      ">
                <tr v-for="(data, index) in DetailModal.form.Aircrafts" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td>
                    {{ data.mainResult }}
                  </td>
                  <td>
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 現金 -->
        <div v-show="DetailModal.MenuIndex === 5" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.grid.currency && DetailModal.grid.currency.length
      ">
                <tr v-for="(data, index) in DetailModal.grid.currency" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.mainResult }}
                  </td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="3" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 存款 -->
        <div v-show="DetailModal.MenuIndex === 6" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Deposits && DetailModal.form.Deposits.length
      ">
                <tr v-for="(data, index) in DetailModal.form.Deposits" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.mainResult }}
                  </td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 有價證券(股票) -->
        <div v-show="DetailModal.MenuIndex === 7" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Stocks && DetailModal.form.Stocks.length">
                <tr v-for="(data, index) in DetailModal.form.Stocks" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.mainResult }}
                  </td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 有價證券(票券，債券，其他有價證券) -->
        <div v-show="DetailModal.MenuIndex === 8" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.BondValuePapers &&
      DetailModal.form.BondValuePapers.length
      ">
                <tr v-for="(data, index) in DetailModal.form.BondValuePapers" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.mainResult }}
                  </td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 有價證券(基金受益憑證) -->
        <div v-show="DetailModal.MenuIndex === 9" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Funds && DetailModal.form.Funds.length">
                <tr v-for="(data, index) in DetailModal.form.Funds" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.mainResult }}
                  </td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 其他財產 -->
        <div v-show="DetailModal.MenuIndex === 10" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.OtherPropertys &&
      DetailModal.form.OtherPropertys.length
      ">
                <tr v-for="(data, index) in DetailModal.form.OtherPropertys" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td>
                    {{ data.mainResult }}
                  </td>
                  <td>
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 保險 -->
        <div v-show="DetailModal.MenuIndex === 11" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Insurances &&
      DetailModal.form.Insurances.length
      ">
                <tr v-for="(data, index) in DetailModal.form.Insurances" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.mainResult }}
                  </td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 債權 -->
        <div v-show="DetailModal.MenuIndex === 12" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Claims && DetailModal.form.Claims.length">
                <tr v-for="(data, index) in DetailModal.form.Claims" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.mainResult }}
                  </td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 債務 -->
        <div v-show="DetailModal.MenuIndex === 13" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Debts && DetailModal.form.Debts.length">
                <tr v-for="(data, index) in DetailModal.form.Debts" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.mainResult }}
                  </td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 事業投資 -->
        <div v-show="DetailModal.MenuIndex === 14" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.Investments &&
      DetailModal.form.Investments.length
      ">
                <tr v-for="(data, index) in DetailModal.form.Investments" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.mainResult }}
                  </td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 備註 -->
        <div v-show="DetailModal.MenuIndex === 15" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>申報內容</th>
                </tr>
                <tr>
                  <td>{{ DetailModal.grid.remark }}</td>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
        <!-- 虛擬資產 -->
        <div v-show="DetailModal.MenuIndex === 16" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>序號</th>
                  <th>申報內容</th>
                  <th colspan="3">查核結果</th>
                  <th>比對結果</th>
                  <th>審核結果</th>
                </tr>
              </thead>
              <tbody v-if="DetailModal.form.VirtualAssets &&
      DetailModal.form.VirtualAssets.length
      ">
                <tr v-for="(data, index) in DetailModal.form.VirtualAssets" :key="index" :style="{
      backgroundColor:
        data.dataChg == '01'
          ? '#90be6d'
          : data.dataChg == '02'
            ? '#f9844a'
            : data.dataChg == '00'
              ? '#84C1FF'
              : '#adb5bd',
    }">
                  <td>{{ data.detailSeq }}</td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.mainResult }}
                  </td>
                  <td :style="{ fontWeight: data.isTotalFlag ? '900' : '' }">
                    {{ data.downResult }}
                  </td>
                  <td>
                    <input type="button" class="btn" value="編" v-show="data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemEdit(data)" />
                    <input type="button" class="btn" value="新增" v-show="!data.hasData && data.kind != '2'"
                      @click="DetailModalBtnItemAdd(data)" />
                  </td>
                  <td v-if="data.downResult !== '' &&
      data.downResult !== null &&
      !data.IsTotalFlag &&
      data.kind != '2'
      ">
                    <span>與序號</span>&nbsp;
                    <select v-model="data.seq">
                      <option value=""></option>
                      <option v-for="(data2, index2) in data.seqs" :key="index2" :value="data2">
                        {{ data2 }}
                      </option>
                    </select>
                    <input type="button" class="btn" value="配對" @click="DetailModalBtnItemMate(data)"
                      :disabled="data.seq == ''" v-show="data.kind == '1'" />
                  </td>
                  <td v-else></td>
                  <td :style="{ color: data.resultColorFlag ? '' : '#ef233c' }">
                    {{ data.verifyResult }}
                  </td>
                  <td>
                    <select v-model="data.verifyStatus">
                      <option value=""></option>
                      <option value="01">相符</option>
                      <option value="02">備查</option>
                      <option value="03">逕行認定非故意申報不實</option>
                      <option value="04">不符，請申報人附佐證資料說明</option>
                      <option value="05">未達申報標準</option>
                    </select>
                    <textarea rows="5" cols="40" v-model="data.verifyNote"></textarea>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>

      <table width="100%" class="itable" style="text-align: left">
        <tbody>
          <tr>
            <th>表格底色說明</th>
          </tr>
          <tr>
            <td>
              <p>1.無使用授權提供資料人員：灰色</p>
              <p>2.使用授權提供資料人員</p>
              <p>(1)資料無調整：藍色</p>
              <p>(2)資料逕行修正：橙色</p>
              <p>(3)自行新增資料：綠色</p>
              <p>3.各項加總小計：粗體灰色</p>
              <p>4.比對結果異常：紅色粗體字</p>
            </td>
          </tr>
        </tbody>
      </table>
    </DetailModal>

    <LandModal v-model="LandModal.show" :title="LandModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>土地坐落</td>
                <td colspan="3">
                  <ul>
                    <li>
                      <input type="text" size="100" maxlength="100" v-model="LandModal.form.address" />
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>面積</td>
                <td>
                  <ul>
                    <li>
                      <input type="text" v-model="LandModal.form.areaSystem" size="10" maxlength="10" />
                      平方公尺
                    </li>
                  </ul>
                </td>
                <td>權利範圍</td>
                <td>
                  <input type="text" size="5" v-model="LandModal.form.rights1" />
                  /
                  <input type="text" size="5" v-model="LandModal.form.rights2" />
                  分子/分母
                </td>
              </tr>
              <tr>
                <td>所有權人</td>
                <td>
                  <select v-model="LandModal.form.ownerIdn">
                    <option v-for="(data, index) in LandModal.dropDownList.owners" :key="index"
                      :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
                <td>登記(取得)時間</td>
                <td>
                  <DatePicker v-model="LandModal.form.enterDate" format="YYYMMDD" :isTaiwanYear="true" clearable
                    placeholder="請輸入/選擇日期" /><br />
                </td>
              </tr>
              <tr>
                <td>登記(取得)原因</td>
                <td>
                  <select v-model="LandModal.form.enterReason">
                    <option v-for="(data, index) in LandModal.dropDownList
      .enterReasons" :key="index" :value="data.mcode">
                      {{ data.mvalue }}
                    </option>
                  </select>
                  <input v-model="LandModal.form.enterReasonText" :disabled="LandModal.form.enterReason != '999'"
                    type="text" class="input" Placeholder="選單選其他項者，須自行輸入原因" size="40" maxlength="40" />
                </td>
                <td>取得價額</td>
                <td><input type="text" v-model="LandModal.form.price" /></td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="LandModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </LandModal>

    <BuildingModal v-model="BuildingModal.show" :title="BuildingModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>地號或門牌號碼</td>
                <td>
                  <input type="text" size="30" maxlength="30" v-model="BuildingModal.form.address" />
                </td>
              </tr>
              <tr>
                <td>建號</td>
                <td>
                  <input type="text" size="20" maxlength="20" v-model="BuildingModal.form.regNo" />
                </td>
              </tr>
              <tr>
                <td>主要建物面積</td>
                <td>
                  <ul>
                    <li>
                      <input placeholder="於輸入共同使用部分時，應空白" title="於輸入共同使用部分時，應空白" type="text" size="30" maxlength="30"
                        v-model="BuildingModal.form.areaSystem" />
                      平方公尺
                    </li>
                  </ul>
                </td>
                <td>附屬建物總面積</td>
                <td>
                  <input placeholder="請將所有附屬建物面積加總" title="請將所有附屬建物面積加總" type="text" size="30" maxlength="30"
                    v-model="BuildingModal.form.attachBuildingAreaSystem" />
                  平方公尺
                </td>
              </tr>
              <tr>
                <td>共同使用部分總面積</td>
                <td>
                  <input placeholder="若為獨立建號，請單獨新增一筆" title="若為獨立建號，請單獨新增一筆" type="text" size="30" maxlength="30"
                    v-model="BuildingModal.form.publicAreaSystem" />
                  平方公尺
                </td>
                <td>權利範圍</td>
                <td>
                  <input type="text" size="5" v-model="BuildingModal.form.rights1" />
                  /
                  <input type="text" size="5" v-model="BuildingModal.form.rights2" />
                  分子/分母
                </td>
              </tr>
              <tr>
                <td>所有權人</td>
                <td>
                  <select v-model="BuildingModal.form.ownerIdn">
                    <option v-for="(data, index) in BuildingModal.dropDownList.owners" :key="index"
                      :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
                <td>登記(取得)時間</td>
                <td>
                  <DatePicker v-model="BuildingModal.form.enterDate" format="YYYMMDD" :isTaiwanYear="true" clearable
                    placeholder="請輸入/選擇日期" /><br />
                </td>
              </tr>
              <tr>
                <td>登記(取得)原因</td>
                <td>
                  <select v-model="BuildingModal.form.enterReason">
                    <option v-for="(data, index) in BuildingModal.dropDownList
      .enterReasons" :key="index" :value="data.mcode">
                      {{ data.mvalue }}
                    </option>
                  </select>
                  <input type="text" class="input" title="選單選其他項者，須自行輸入原因" placeholder="選單選其他項者，須自行輸入原因"
                    :disabled="BuildingModal.form.enterReason != '999'" size="40" maxlength="40"
                    v-model="BuildingModal.form.enterReasonText" />
                </td>
                <td>取得價額</td>
                <td>
                  <input type="text" v-model="BuildingModal.form.price" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="BuildingModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </BuildingModal>

    <VesselModal v-model="VesselModal.show" :title="VesselModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>種類</td>
                <td colspan="3">
                  <ul>
                    <select v-model="VesselModal.form.vesselType">
                      <option v-for="(data, index) in VesselModal.dropDownList
      .vesselTypes" :key="index" :value="data.mcode">
                        {{ data.mvalue }}
                      </option>
                    </select>
                    <input type="text" class="input" title="選單選其他項者，須自行輸入種類" placeholder="選單選其他項者，須自行輸入種類"
                      v-model="VesselModal.form.vesselTypeText" :disabled="VesselModal.form.vesselType != '999'"
                      size="40" maxlength="40" />
                    <li></li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>總噸數(長度、管數)</td>
                <td>
                  <ul>
                    <li>
                      <input type="text" v-model="VesselModal.form.ton" size="10" maxlength="10" />
                      噸(公尺、管)
                    </li>
                  </ul>
                </td>
                <td>船籍港</td>
                <td>
                  <input type="text" v-model="VesselModal.form.portReg" size="40" maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>所有人</td>
                <td>
                  <select v-model="VesselModal.form.ownerIdn">
                    <option v-for="(data, index) in VesselModal.dropDownList.owners" :key="index"
                      :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
                <td>登記(取得)時間</td>
                <td>
                  <DatePicker v-model="VesselModal.form.enterDate" format="YYYMMDD" :isTaiwanYear="true" clearable
                    placeholder="請輸入/選擇日期" /><br />
                </td>
              </tr>
              <tr>
                <td>登記(取得)原因</td>
                <td>
                  <select v-model="VesselModal.form.enterReason">
                    <option v-for="(data, index) in VesselModal.dropDownList
      .enterReasons" :key="index" :value="data.mcode">
                      {{ data.mvalue }}
                    </option>
                  </select>
                  <input type="text" class="input" title="選單選其他項者，須自行輸入原因" placeholder="選單選其他項者，須自行輸入原因"
                    v-model="VesselModal.form.enterReasonText" :disabled="VesselModal.form.enterReason != '999'"
                    size="40" maxlength="40" />
                </td>
                <td>取得價額</td>
                <td><input type="text" v-model="VesselModal.form.price" /></td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="VesselModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </VesselModal>

    <VehicleModal v-model="VehicleModal.show" :title="VehicleModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>種類</td>
                <td colspan="3">
                  <ul>
                    <select v-model="VehicleModal.form.vehicleType">
                      <option v-for="(data, index) in VehicleModal.dropDownList.vehicleTypes" :value="data.mcode" :key="index">
                        {{ data.mvalue }}
                      </option>
                    </select>
                    <input type="text" class="input" title="選單選其他項者，須自行輸入種類" placeholder="選單選其他項者，須自行輸入種類"
                      :disabled="VehicleModal.form.vehicleType != '999'" v-model="VehicleModal.form.vehicleTypeText"
                      size="40" maxlength="40" />
                    <li></li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>廠牌型號</td>
                <td>
                  <ul>
                    <li>
                      <input type="text" size="40" v-model="VehicleModal.form.brand" maxlength="40" />
                    </li>
                  </ul>
                </td>
                <td>汽缸容量</td>
                <td>
                  <input type="text" v-model="VehicleModal.form.volume" size="10" maxlength="10" />
                  C.C.
                </td>
              </tr>
              <tr>
                <td>
                  <select title="可選牌照號碼或引擎號碼擇一輸入" v-model="VehicleModal.form.islicenseNo">
                    <option value="01">牌照號碼</option>
                    <option value="02">引擎號碼</option>
                  </select>
                </td>
                <td valign="middle">
                  <input placeholder="可選牌照或引擎號碼擇一輸入" v-model="VehicleModal.form.licenseNo" type="text" size="40"
                    maxlength="40" />
                </td>
                <td>
                  <p>所有人<br /></p>
                </td>
                <td valign="middle">
                  <select v-model="VehicleModal.form.ownerIdn">
                    <option v-for="(data, index) in VehicleModal.dropDownList.owners" :key="index"
                      :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>登記(取得)時間</td>
                <td>
                  <DatePicker v-model="VehicleModal.form.enterDate" format="YYYMMDD" :isTaiwanYear="true" clearable
                    placeholder="請輸入/選擇日期" /><br />
                </td>
              </tr>
              <tr>
                <td>登記(取得)原因</td>
                <td>
                  <select v-model="VehicleModal.form.enterReason">
                    <option v-for="(data, index) in VehicleModal.dropDownList.enterReasons" :key="index" :value="data.mcode">
                      {{ data.mvalue }}
                    </option>
                  </select>
                  <input type="text" class="input" title="選單選其他項者，須自行輸入原因" placeholder="選單選其他項者，須自行輸入原因"
                    v-model="VehicleModal.form.enterReasonText" :disabled="VehicleModal.form.enterReason != '999'"
                    size="40" maxlength="40" />
                </td>
                <td>取得價額</td>
                <td><input type="text" v-model="VehicleModal.form.price" /></td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="VehicleModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </VehicleModal>

    <AircraftModal v-model="AircraftModal.show" :title="AircraftModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>型式</td>
                <td colspan="3">
                  <ul>
                    <input type="text" class="input" v-model="AircraftModal.form.aircraftType" size="40"
                      maxlength="40" />
                    <li></li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>製造廠名稱</td>
                <td>
                  <ul>
                    <li>
                      <input type="text" v-model="AircraftModal.form.factoryName" size="40" maxlength="40" />
                    </li>
                  </ul>
                </td>
                <td>國籍標示及編號</td>
                <td>
                  <input type="text" v-model="AircraftModal.form.nationNumber" size="20" maxlength="20" />
                </td>
              </tr>
              <tr>
                <td>
                  <p>所有人<br /></p>
                </td>
                <td valign="middle">
                  <select v-model="AircraftModal.form.ownerIdn">
                    <option v-for="(data, index) in AircraftModal.dropDownList.owners" :key="index"
                      :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
                <td>登記(取得)時間</td>
                <td>
                  <DatePicker v-model="AircraftModal.form.enterDate" format="YYYMMDD" :isTaiwanYear="true" clearable
                    placeholder="請輸入/選擇日期" /><br />
                </td>
              </tr>
              <tr>
                <td>登記(取得)原因</td>
                <td>
                  <select v-model="AircraftModal.form.enterReason">
                    <option v-for="(data, index) in AircraftModal.dropDownList
      .enterReasons" :key="index" :value="data.mcode">
                      {{ data.mvalue }}
                    </option>
                  </select>
                  <input v-model="AircraftModal.form.enterReasonText"
                    :disabled="AircraftModal.form.enterReason != '999'" type="text" class="input"
                    Placeholder="選單選其他項者，須自行輸入原因" size="40" maxlength="40" />
                </td>
                <td>取得價額</td>
                <td>
                  <input type="text" v-model="AircraftModal.form.price" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="AircraftModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </AircraftModal>

    <CurrencyModal v-model="CurrencyModal.show" :title="CurrencyModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>外幣總額</td>
                <td>
                  <input type="text" v-model="CurrencyModal.form.foreignSum" size="20" maxlength="20"
                    v-on:change="caculateCurrency()" />
                  幣別
                  <select v-model="CurrencyModal.form.currency">
                    <option v-for="(data, index) in CurrencyModal.dropDownList
      .coinTypes" :key="index" :value="data.mcode">
                      {{ data.mvalue }}
                    </option>
                  </select>
                  匯率
                  <input type="text" v-model="CurrencyModal.form.excRate" size="5" maxlength="5"
                    v-on:change="caculateCurrency()" />
                  <a href="https://rate.bot.com.tw/xrt/history?lang=zh-TW"><u>臺灣銀行歷史匯率查詢</u></a>
                </td>
              </tr>
              <tr>
                <td>新臺幣總額或折合新臺幣總額</td>
                <td>
                  <input type="text" v-model="CurrencyModal.form.twdSum"
                    :disabled="!(CurrencyModal.form.currency == '1' || CurrencyModal.form.currency == '42')" size="20"
                    maxlength="20" />
                </td>
              </tr>
              <tr>
                <td>所有人</td>
                <td>
                  <select v-model="CurrencyModal.form.ownerIdn">
                    <option v-for="(data, index) in CurrencyModal.dropDownList.owners" :key="index"
                      :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="DepositModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </CurrencyModal>

    <DepositModal v-model="DepositModal.show" :title="DepositModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>類別</td>
                <td>
                  <ul>
                    <li>
                      <label>
                        <input type="radio" value="1" v-model="DepositModal.form.category" />
                        新臺幣存款</label>
                      <label>
                        <input type="radio" value="2" v-model="DepositModal.form.category" />
                        外幣存款</label>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>種類</td>
                <td>
                  <select v-model="DepositModal.form.depositType">
                    <option v-for="(data, index) in DepositModal.dropDownList
      .categorys" :key="index" :value="data.mcode">
                      {{ data.mvalue }}
                    </option>
                  </select>
                  <input type="text" class="input" title="選單選其他項者，須自行輸入" placeholder="選單選其他項者，須自行輸入"
                    v-model="DepositModal.form.depositTypeText" :disabled="DepositModal.form.depositType != '999'"
                    size="40" maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>
                  <p>存放機構<br /></p>
                </td>
                <td>
                  <ul>
                    <input type="text" class="input" v-model="DepositModal.form.institution" size="40" maxlength="40" />
                  </ul>
                </td>
              </tr>
              <tr v-show="DepositModal.form.category == '2'">
                <td>外幣總額</td>
                <td>
                  <input type="text" v-model="DepositModal.form.foreignSum" size="20" maxlength="20"
                    v-on:change="caculate()" />
                  幣別
                  <select v-model="DepositModal.form.currency">
                    <option v-for="(data, index) in DepositModal.dropDownList
      .coinTypes" :key="index" :value="data.mcode">
                      {{ data.mvalue }}
                    </option>
                  </select>
                  匯率
                  <input type="text" v-model="DepositModal.form.excRate" size="5" maxlength="5"
                    v-on:change="caculate()" />
                  <a href="https://rate.bot.com.tw/xrt/history?lang=zh-TW"><u>臺灣銀行歷史匯率查詢</u></a>
                </td>
              </tr>
              <tr>
                <td>新臺幣總額或折合新臺幣總額</td>
                <td>
                  <input type="text" v-model="DepositModal.form.twdSum" :disabled="DepositModal.form.category == '2'"
                    size="20" maxlength="20" />
                </td>
              </tr>
              <tr>
                <td>所有人</td>
                <td>
                  <select v-model="DepositModal.form.ownerIdn">
                    <option v-for="(data, index) in DepositModal.dropDownList.owners" :key="index"
                      :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="DepositModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </DepositModal>

    <StockModal v-model="StockModal.show" :title="StockModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>所有人</td>
                <td colspan="3">
                  <select v-model="StockModal.form.ownerIdn">
                    <option v-for="(data, index) in StockModal.dropDownList.owners" :key="index"
                      :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>股票代碼/名稱</td>
                <td colspan="3">
                  <ul>
                    <input type="text" v-model="StockModal.form.stockCode" size="10" maxlength="10" />／
                    <input type="text" v-model="StockModal.form.stockName" size="40" maxlength="40" />
                  </ul>
                </td>
              </tr>
              <tr>
                <td>股數</td>
                <td>
                  <input type="text" v-model="StockModal.form.share" size="20" maxlength="20"
                    v-on:change="caculateStockBond1()" />
                </td>
                <td>票面價額</td>
                <td>
                  <input type="text" v-model="StockModal.form.parValue" size="20" maxlength="20"
                    v-on:change="caculateStockBond1()" />
                </td>
              </tr>
              <tr>
                <td>幣別</td>
                <td>
                  <select v-model="StockModal.form.currency">
                    <option v-for="(data, index) in StockModal.dropDownList.coinTypes" :value="data.mcode" :key="index">
                      {{ data.mvalue }}
                    </option>
                  </select>
                </td>
                <td>匯率</td>
                <td>
                  <input type="text" v-model="StockModal.form.excRate" size="20" maxlength="20"
                    v-on:change="caculateStockBond1()" />
                </td>
              </tr>
              <tr>
                <td>新臺幣總額或折合新臺幣總額</td>
                <td colspan="3">
                  <input type="text" v-model="StockModal.form.twdSum" size="20" maxlength="20" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="StockModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </StockModal>

    <BondValuePaperModal v-model="BondValuePaperModal.show" :title="BondValuePaperModal.title"
      :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>所有人</td>
                <td colspan="3">
                  <select v-model="BondValuePaperModal.form.ownerIdn">
                    <option v-for="(data, index) in BondValuePaperModal.dropDownList
      .owners" :key="index" :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>代碼/名稱</td>
                <td colspan="3">
                  <ul>
                    <input type="text" v-model="BondValuePaperModal.form.stockCode" size="10" maxlength="10" />／
                    <input type="text" v-model="BondValuePaperModal.form.stockName" size="40" maxlength="40" />
                  </ul>
                </td>
              </tr>
              <tr>
                <td>單位數</td>
                <td>
                  <input type="text" v-model="BondValuePaperModal.form.share" size="20" maxlength="20" />
                </td>
                <td>票面價額</td>
                <td>
                  <input type="text" v-model="BondValuePaperModal.form.parValue" size="20" maxlength="20" />
                </td>
              </tr>
              <tr>
                <td>幣別</td>
                <td>
                  <select v-model="BondValuePaperModal.form.currency">
                    <option v-for="(data, index) in BondValuePaperModal.dropDownList
      .coinTypes" :value="data.mcode" :key="index">
                      {{ data.mvalue }}
                    </option>
                  </select>
                </td>
                <td>匯率</td>
                <td>
                  <input type="text" v-model="BondValuePaperModal.form.excRate" size="20" maxlength="20" />
                </td>
              </tr>
              <tr>
                <td>新臺幣總額或折合新臺幣總額</td>
                <td colspan="3">
                  <input type="text" v-model="BondValuePaperModal.form.twdSum" size="20" maxlength="20" />
                </td>
              </tr>
              <tr>
                <td>買賣機構或受託投資機構</td>
                <td>
                  <input type="text" class="input" v-model="BondValuePaperModal.form.institution" size="40"
                    maxlength="40" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="BondValuePaperModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </BondValuePaperModal>

    <FundModal v-model="FundModal.show" :title="FundModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>所有人</td>
                <td colspan="3">
                  <select v-model="FundModal.form.ownerIdn">
                    <option v-for="(data, index) in FundModal.dropDownList.owners" :key="index"
                      :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>代碼/名稱</td>
                <td colspan="3">
                  <ul>
                    <input type="text" v-model="FundModal.form.stockName" size="40" maxlength="40" />
                  </ul>
                </td>
              </tr>
              <tr>
                <td>單位數</td>
                <td>
                  <input type="text" v-model="FundModal.form.share" size="20" maxlength="20" />
                </td>
                <td>票面價額/單位淨值</td>
                <td>
                  <input type="text" v-model="FundModal.form.parValue" size="20" maxlength="20" />
                </td>
              </tr>
              <tr>
                <td>幣別</td>
                <td>
                  <select v-model="FundModal.form.currency">
                    <option v-for="(data, index) in FundModal.dropDownList.coinTypes" :value="data.mcode" :key="index">
                      {{ data.mvalue }}
                    </option>
                  </select>
                </td>
                <td>匯率</td>
                <td>
                  <input type="text" v-model="FundModal.form.excRate" size="20" maxlength="20" />
                </td>
              </tr>
              <tr>
                <td>新臺幣總額或折合新臺幣總額</td>
                <td colspan="3">
                  <input type="text" size="20" maxlength="20" v-model="FundModal.form.twdSum" />
                </td>
              </tr>
              <tr>
                <td>受託投資機構</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="FundModal.form.institution" size="40" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="FundModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </FundModal>

    <OtherPropertyModal v-model="OtherPropertyModal.show" :title="OtherPropertyModal.title"
      :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>財產種類</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="OtherPropertyModal.form.otherPropertiesType" size="40"
                    maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>所有人</td>
                <td>
                  <select v-model="OtherPropertyModal.form.ownerIdn">
                    <option v-for="(data, index) in OtherPropertyModal.dropDownList
      .owners" :key="index" :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
                <td>項/件</td>
                <td>
                  <input type="text" class="input" v-model="OtherPropertyModal.form.otherQuantity" size="40"
                    maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>價額</td>
                <td colspan="3">
                  <input type="text" v-model="OtherPropertyModal.form.price" size="20" maxlength="20" />
                  元
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="OtherPropertyModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </OtherPropertyModal>

    <InsuranceModal v-model="InsuranceModal.show" :title="InsuranceModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>保險公司</td>
                <td colspan="3">
                  <ul>
                    <p>
                      <select v-model="InsuranceModal.form.companyName">
                        <option v-for="(data, index) in InsuranceModal.dropDownList
      .companyNames" :key="index" :value="data.mcode">
                          {{ data.mvalue }}
                        </option>
                      </select>
                      <br />
                      <input type="text" class="input" v-model="InsuranceModal.form.companyNameText"
                        :disabled="InsuranceModal.form.companyName != '999'" title="選單選其他項者，可自行輸入"
                        placeholder="選單選其他項者，可自行輸入" size="40" maxlength="40" />
                      <br />
                    </p>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>保險名稱</td>
                <td>
                  <input type="text" class="input" v-model="InsuranceModal.form.insuranceName" size="40"
                    maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>要保人</td>
                <td>
                  <select v-model="InsuranceModal.form.ownerIdn">
                    <option v-for="(data, index) in InsuranceModal.dropDownList
      .owners" :key="index" :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>備註</td>
                <td>
                  <textarea cols="50" rows="5" v-model="InsuranceModal.form.remark" maxlength="20"></textarea>
                </td>
              </tr>
              <tr v-show="InsuranceModal.isNew || InsuranceModal.isNew2">
                <td>保單號碼</td>
                <td>
                  <input type="text" class="input" id="textfield4" v-model="InsuranceModal.form.insuranceNo" size="40"
                    maxlength="40" />
                </td>
                <td>保險契約類型</td>
                <td>
                  <select name="select" id="select" v-model="InsuranceModal.form.contractType">
                    <option>儲蓄型壽險</option>
                    <option>投資型壽險</option>
                    <option>年金型保險</option>
                  </select>
                </td>
              </tr>
              <tr v-show="InsuranceModal.isNew || InsuranceModal.isNew2">
                <td>契約始日</td>
                <td>
                  <input type="text" class="input" size="7" maxlength="7" v-model="InsuranceModal.form.startDate" />
                </td>
                <td>契約終日</td>
                <td>
                  <input type="text" class="input" size="7" maxlength="7" v-model="InsuranceModal.form.endDate" />
                </td>
              </tr>
              <tr v-show="InsuranceModal.isNew">
                <td>保險金額</td>
                <td>
                  <ul>
                    <input type="text" class="input" v-model="InsuranceModal.form.amount" size="20" maxlength="20" />
                  </ul>
                </td>
                <td>幣別</td>
                <td>
                  <select v-model="InsuranceModal.form.currency">
                    <option v-for="(data, index) in InsuranceModal.dropDownList
      .coinTypes" :key="index" :value="data.mcode">
                      {{ data.mvalue }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr v-show="InsuranceModal.isNew">
                <td>累積已繳保險金額</td>
                <td>
                  <ul>
                    <input type="text" class="input" v-model="InsuranceModal.form.contractAggregatePremium" size="20"
                      maxlength="20" />
                  </ul>
                </td>
                <td>匯率</td>
                <td>
                  <ul>
                    <input type="text" class="input" v-model="InsuranceModal.form.rate" size="20" maxlength="20" />
                  </ul>
                </td>
              </tr>
              <tr v-show="InsuranceModal.isNew">
                <td>累積已繳保險金額折合新臺幣總額</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="InsuranceModal.form.contractAggregatePremiumNt" size="20"
                    maxlength="20" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="InsuranceModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </InsuranceModal>

    <ClaimModal v-model="ClaimModal.show" :title="ClaimModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>種類</td>
                <td colspan="3">
                  <ul>
                    <p>
                      <input type="text" class="input" v-model="ClaimModal.form.claimsType" size="40" maxlength="40" />
                      <br />
                    </p>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>債權人</td>
                <td>
                  <select v-model="ClaimModal.form.ownerIdn">
                    <option v-for="(data, index) in ClaimModal.dropDownList.owners" :key="index"
                      :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
                <td>債務人</td>
                <td>
                  <input type="text" class="input" v-model="ClaimModal.form.debtorName" size="40" maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>債務人地圵</td>
                <td>
                  <input type="text" class="input" v-model="ClaimModal.form.debtorAddr" size="40" maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>餘額</td>
                <td>
                  <ul>
                    <input type="text" v-model="ClaimModal.form.twdSum" size="20" maxlength="20" />
                  </ul>
                </td>
                <td>取得(發生)時間</td>
                <td>
                  <DatePicker v-model="ClaimModal.form.enterDate" format="YYYMDD" :isTaiwanYear="true" clearable
                    placeholder="請輸入/選擇日期" /><br />
                </td>
              </tr>
              <tr>
                <td>取得(發生)原因</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="ClaimModal.form.enterReason" size="40" maxlength="80" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="ClaimModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </ClaimModal>

    <DebtModal v-model="DebtModal.show" :title="DebtModal.title" :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>種類</td>
                <td colspan="3">
                  <ul>
                    <p>
                      <select v-model="DebtModal.form.debtType">
                        <option v-for="(data, index) in DebtModal.dropDownList
      .debtTypes" :key="index" :value="data.mcode">
                          {{ data.mvalue }}
                        </option>
                      </select>
                      <input type="text" class="input" title="選單選其他項者，可自行輸入" placeholder="選單選其他項者，可自行輸入"
                        v-model="DebtModal.form.debtTypeText" :disabled="DebtModal.form.debtType != '999'" size="40"
                        maxlength="40" />
                      <br />
                    </p>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>債務人</td>
                <td>
                  <select v-model="DebtModal.form.ownerIdn">
                    <option v-for="(data, index) in DebtModal.dropDownList.owners" :key="index"
                      :value="data.idnOrPassportno">
                      {{ data.name }}
                    </option>
                  </select>
                </td>
                <td>債權人</td>
                <td>
                  <input type="text" class="input" v-model="DebtModal.form.claimsName" size="40" maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>債權人地圵</td>
                <td>
                  <input type="text" class="input" v-model="DebtModal.form.claimsAddr" size="40" maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>餘額</td>
                <td>
                  <ul>
                    <input type="text" v-model="DebtModal.form.twdSum" size="20" maxlength="20" />
                  </ul>
                </td>
                <td>取得(發生)時間</td>
                <td>
                  <DatePicker v-model="DebtModal.form.enterDate" format="YYYMMDD" :isTaiwanYear="true" clearable
                    placeholder="請輸入/選擇日期" /><br />
                </td>
              </tr>
              <tr>
                <td>取得(發生)原因</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="DebtModal.form.enterReason" size="40" maxlength="80" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="DebtModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </DebtModal>

    <InvestmentModal v-model="InvestmentModal.show" :title="InvestmentModal.title"
      :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>投資人</td>
                <td colspan="3">
                  <ul>
                    <p>
                      <select v-model="InvestmentModal.form.ownerIdn">
                        <option v-for="(data, index) in InvestmentModal.dropDownList
      .owners" :key="index" :value="data.idnOrPassportno">
                          {{ data.name }}
                        </option>
                      </select>
                      <br />
                    </p>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>投資事業名稱</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="InvestmentModal.form.companyName" size="40"
                    maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>事業投資地圵</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="InvestmentModal.form.companyAddress" size="40"
                    maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>投資金額</td>
                <td>
                  <ul>
                    <input type="text" v-model="InvestmentModal.form.priceTotal" size="20" maxlength="20" />
                  </ul>
                </td>
                <td>取得(發生)時間</td>
                <td>
                  <DatePicker v-model="InvestmentModal.form.enterDate" format="YYYMMDD" :isTaiwanYear="true" clearable
                    placeholder="請輸入/選擇日期" /><br />
                </td>
              </tr>
              <tr>
                <td>取得(發生)原因</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="InvestmentModal.form.enterReason" size="40"
                    maxlength="80" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="InvestmentModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </InvestmentModal>

    <VirtualAssetsModal v-model="VirtualAssetsModal.show" :title="VirtualAssetsModal.title"
      :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>虛擬資產名稱</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="VirtualAssetsModal.form.virtualAssetName" size="40"
                    maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>所有人</td>
                <td colspan="3">
                  <ul>
                    <p>
                      <select v-model="VirtualAssetsModal.form.owners">
                        <option v-for="(data, index) in VirtualAssetsModal.dropDownList
      .owners" :key="index" :value="data.idnOrPassportno">
                          {{ data.name }}
                        </option>
                      </select>
                      <br />
                    </p>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>單位數</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="VirtualAssetsModal.form.amount" size="10"
                    maxlength="10" />
                </td>
              </tr>
              <tr>
                <td>單位</td>
                <td colspan="3">
                    <ul>
                    <p>
                      <select v-model="VirtualAssetsModal.form.amountUnit">
                        <option value="顆">顆</option>
                        <option value="件">件</option>
                      </select>
                    </p>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>存放機構</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="VirtualAssetsModal.form.institution" size="40"
                    maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>帳戶名稱</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="VirtualAssetsModal.form.account" size="40"
                    maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>取得(投資)原因</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="VirtualAssetsModal.form.enterReason" size="40"
                    maxlength="40" />
                </td>
              </tr>
              <tr>
                <td>新臺幣或折合新臺幣交易價額</td>
                <td colspan="3">
                  <input type="text" class="input" v-model="VirtualAssetsModal.form.twdSum" size="40"
                    maxlength="20" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"><span>
                      <input type="button" class="btn" value="存檔" @click="DetailModalItemBtnSave()" />
                      <input type="button" class="btn" value="刪除" :disabled="VirtualAssetsModal.modifiedType !== 'U'"
                        @click="DetailModalItemBtnDelete()" />
                      <input type="submit" class="btn" value="重填" @click="DetailModalItemBtnClear()" /> </span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </VirtualAssetsModal>

    <A101DetailModal v-model="A101DetailModal.show" :title="A101DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }">
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>服務機關</td>
                <td colspan="3">
                  <select v-model="A101DetailModal.form.jobGovCode1" style="min-width: 200px" disabled>
                    <option v-for="(item, index) in A101DetailModal.dropDownList
      .jobGovCode1s" :value="item.value" :key="index">
                      {{ item.text }}
                    </option>
                  </select>
                  <select v-model="A101DetailModal.form.jobGovCode2" style="min-width: 200px" disabled>
                    <option v-for="(item, index) in A101DetailModal.dropDownList
      .jobGovCode2s" :value="item.value" :key="index">
                      {{ item.text }}
                    </option>
                  </select>
                  <select v-model="A101DetailModal.form.jobGovCode3" style="min-width: 200px" disabled>
                    <option v-for="(item, index) in A101DetailModal.dropDownList
      .jobGovCode3s" :value="item.value" :key="index">
                      {{ item.text }}
                    </option>
                  </select>
                  <select v-model="A101DetailModal.form.jobGovCode4" style="min-width: 200px" disabled>
                    <option v-for="(item, index) in A101DetailModal.dropDownList
      .jobGovCode4s" :value="item.value" :key="index">
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select v-model="A101DetailModal.form.govCode1" style="min-width: 200px" disabled>
                    <option v-for="(item, index) in A101DetailModal.dropDownList
      .govCode1s" :value="item.value" :key="index">
                      {{ item.text }}
                    </option>
                  </select>
                  <select v-model="A101DetailModal.form.govCode2" style="min-width: 200px" disabled>
                    <option v-for="(item, index) in A101DetailModal.dropDownList
      .govCode2s" :value="item.value" :key="index">
                      {{ item.text }}
                    </option>
                  </select>
                  <select v-model="A101DetailModal.form.govCode3" style="min-width: 200px" disabled>
                    <option v-for="(item, index) in A101DetailModal.dropDownList
      .govCode3s" :value="item.value" :key="index">
                      {{ item.text }}
                    </option>
                  </select>
                  <select v-model="A101DetailModal.form.govCode4" style="min-width: 200px" disabled>
                    <option v-for="(item, index) in A101DetailModal.dropDownList
      .govCode4s" :value="item.value" :key="index">
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>身分證統一編號/居留證號</td>
                <td>
                  <input type="text" maxlength="20" v-model="A101DetailModal.form.idn" disabled />
                </td>
                <td>姓名</td>
                <td>
                  <input type="text" v-model="A101DetailModal.form.name" disabled />
                </td>
              </tr>
              <tr>
                <td>生日</td>
                <td colspan="3">
                  <DatePicker v-model="A101DetailModal.form.birthday" format="YYYMMDD" :isTaiwanYear="true" clearable
                    placeholder="請輸入/選擇日期" disabled />
                </td>
              </tr>
              <tr>
                <td>單位及職稱</td>
                <td>
                  <input type="text" v-model="A101DetailModal.form.title" disabled />
                </td>
                <td>階級</td>
                <td>
                  <select v-model="A101DetailModal.form.rank" disabled>
                    <option value="">無</option>
                    <option value="1">上將</option>
                    <option value="2">中將</option>
                    <option value="3">少將</option>
                    <option value="4">上校</option>
                    <option value="5">中校</option>
                    <option value="6">少校</option>
                    <option value="7">上尉</option>
                    <option value="8">中尉</option>
                    <option value="9">少尉</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>聯絡電話</td>
                <td>
                  <input type="text" v-model="A101DetailModal.form.tel" size="20" maxlength="20" disabled />
                </td>
                <td>E-Mail</td>
                <td>
                  <input type="text" v-model="A101DetailModal.form.email" size="20" maxlength="40" disabled />
                </td>
              </tr>
              <tr>
                <td>到職日</td>
                <td>
                  <DatePicker v-model="A101DetailModal.form.arriveDate" format="YYYMMDD" :isTaiwanYear="true" clearable
                    placeholder="請輸入/選擇日期" disabled />
                </td>
                <td>去職日</td>
                <td>
                  <DatePicker v-model="A101DetailModal.form.leaveDate" format="YYYMMDD" :isTaiwanYear="true" clearable
                    placeholder="請輸入/選擇日期" disabled />
                </td>
              </tr>
              <tr>
                <td>現職狀況</td>
                <td colspan="3">
                  <select v-model="A101DetailModal.form.leave" style="min-width: 480px" disabled>
                    <option v-for="(item, index) in A101DetailModal.dropDownList
      .onJobs" :value="item.value" :key="index">
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>應申報身分資格</td>
                <td colspan="3">
                  <select v-model="A101DetailModal.form.status" style="max-width: 1000px" disabled>
                    <option v-for="(item, index) in A101DetailModal.dropDownList
      .OnDeclare" :value="item.mcode" :key="index">
                      {{ item.mvalue }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>備註</td>
                <td colspan="3">
                  <p>
                    <input type="text" v-model="A101DetailModal.form.leave_Reason" size="80" maxlength="80" disabled />
                    <br />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </A101DetailModal>

    <Alert v-model="Alert.show" :title="Alert.title" :enableClose="Alert.enableClose">
      <div style="text-align: center">
        <div v-for="(data, index) in Alert.txt" :key="index" style="margin-bottom: 10px">
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import Timeout from "@//components/Common/Timeout.vue";
import { getMenuIndex, getMenu, logOut } from "@/config/util.js";
import {
  SearchGovCode,
  SearchGridOnJob,
  SearchGridOnDeclare,
  A101_DetailInit,
  GetLandDropDownMenu,
  GetBuildingDropDownMenu,
  GetVesselDropDownMenu,
  GetVehicleDropDownMenu,
  GetAircraftDropDownMenu,
  GetDepositDropDownMenu,
  GetCurrencyDropDownMenu,
  GetSecuritiesDropDownMenu,
  GetInsuranceDropDownMenu,
  GetDebtDropDownMenu,
  F201_matchVerifyResult,
  F201_SearchGrid,
  F201_ReSearchGrid,
  F201_SearchGrid2,
  F201_mappingData,
  F201_updateVerifyResult,
  F201_searchText2Object,
  F201_printVerifyResult_Docx,
  F201_printVerifyNoMatchResult_Docx,
  F201_updateVerifyLandData,
  F201_updateVerifyBuildingData,
  F201_updateVerifyVesselData,
  F201_updateVerifyVehicleData,
  F201_updateVerifyAircraftData,
  F201_updateVerifyDepositData,
  F201_updateVerifyStockData,
  F201_updateVerifyBondValuePaperData,
  F201_updateVerifyFundData,
  F201_updateVerifyOtherPropertyData,
  F201_updateVerifyInsuranceData,
  F201_updateVerifyClaimData,
  F201_updateVerifyDebtData,
  F201_updateVerifyInvestmentData,
  F201_updateVerifyCurrencyData,
  F201_updateVerifyVirtualAssetsData,
} from "@/service/api.js";
export default {
  name: "F201",
  data: function () {
    return {
      pageData: {
        MenuIndex: 4,
        MenuName: "",
        PrgName: "F201",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      form: {
        idn: "",
        name: "",
        syear: String(new Date().getFullYear() - 1911 - 1),
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        printtype: "DOCX",
        pagesize: 10,
        currentpage: 1,
      },
      dropDownList: {
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
        syears: [],
      },
      grid: {},
      DetailModal: {
        pagesize: 20,
        currentpage: 1,
        show: false,
        title: "N101財產申報資料審核作業-審核",
        PreData: {},
        showVirtualAssets: false,
        form: {
          name: "",
          idn: "",
          dtype: "",
          sdate: "",
          datetime: "",
          //選單form物件
          Lands: [],
          Buildings: [],
          Vessels: [],
          Vehicles: [],
          Aircrafts: [],
          Currencys: [],
          Deposits: [],
          Stocks: [],
          BondValuePapers: [],
          Funds: [],
          OtherPropertys: [],
          Insurances: [],
          Claims: [],
          Debts: [],
          Investments: [],
          VirtualAssets: [],
        },
        grid: {},
        MenuIndex: 0,
      },
      A101DetailModal: {
        show: false,
        title: "A101申報人基本資料",
        form: {
          govCode1: "",
          govCode2: "",
          govCode3: "",
          govCode4: "",
          jobGovCode1: "",
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          idn: "",
          name: "",
          birthday: "",
          title: "",
          rank: "",
          tel: "",
          email: "",
          arriveDate: "",
          leaveDate: "",
          //現職狀況
          leave: "",
          //應申報身分資格
          status: "",
          //備註
          leave_Reason: "",
        },
        modifyType: "", //"I,U"
        dropDownList: {
          govCode1s: [],
          govCode2s: [],
          govCode3s: [],
          govCode4s: [],
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
          OnDeclare: [],
          onJobs: [],
        },
        PreData: {},
      },
      //modifiedType // 新增查核資料 => 'NI', 新增 => 'I, 編輯 => 'U' , 刪除 => 'D'
      LandModal: {
        show: false,
        title: "N101財產申報資料審核作業(土地)-編輯查核資料",
        PreData: {},
        form: {
          address: "",
          areaSystem: "",
          rights1: "",
          rights2: "",
          ownerIdn: "",
          enterDate: "",
          enterReason: "",
          enterReasonText: "",
          price: "",
        },
        dropDownList: {
          owners: [],
          enterReasons: [],
        },
        modifiedType: "",
      },
      BuildingModal: {
        show: false,
        title: "N101財產申報資料審核作業(建物)-編輯查核資料",
        PreData: {},
        form: {
          address: "",
          regNo: "",
          areaSystem: "",
          rights1: "",
          rights2: "",
          ownerIdn: "",
          attachBuildingAreaSystem: "",
          publicAreaSystem: "",
          enterDate: "",
          enterReason: "",
          enterReasonText: "",
          price: "",
        },
        dropDownList: {
          owners: [],
          enterReasons: [],
        },
        modifiedType: "",
      },
      VesselModal: {
        show: false,
        title: "N101財產申報資料審核作業(船舶)-編輯查核資料",
        PreData: {},
        form: {
          vesselType: "",
          vesselTypeText: "",
          ton: "",
          portReg: "",
          ownerIdn: "",
          owner: "",
          enterDate: "",
          enterReason: "",
          enterReasonText: "",
          price: "",
        },
        dropDownList: {
          vesselTypes: [],
          owners: [],
          enterReasons: [],
        },
        modifiedType: "",
      },
      VehicleModal: {
        show: false,
        title: "N101財產申報資料審核作業(汽車)-編輯查核資料",
        PreData: {},
        form: {
          vehicleType: "",
          vehicleTypeText: "",
          volume: "",
          islicenseNo: "01",
          licenseNo: "",
          ownerIdn: "",
          owner: "",
          brand: "",
          enterDate: "",
          enterReason: "",
          enterReasonText: "",
          price: "",
        },
        dropDownList: {
          vehicleTypes: [],
          enterReasons: [],
          owners: [],
        },
        modifiedType: "",
      },
      AircraftModal: {
        show: false,
        title: "N101財產申報資料審核作業(航空器)-編輯查核資料",
        PreData: {},
        form: {
          aircraftType: "",
          factoryName: "",
          nationNumber: "",
          ownerIdn: "",
          owner: "",
          enterDate: "",
          enterReason: "",
          enterReasonText: "",
          price: "",
        },
        dropDownList: {
          enterReasons: [],
          owners: [],
        },
        modifiedType: "",
      },
      CurrencyModal: {
        show: false,
        title: 'F201財產申報資料審核作業(現金)-編輯查核資料',
        PreData: {},
        form: {
          foreignSum: "",
          currency: "",
          excRate: "",
          twdSum: "",
          ownerIdn: "",
          owner: "",
        },
        dropDownList: {
          coinTypes: [],
          owners: [],
        },
        modifiedType: "",
      },
      DepositModal: {
        show: false,
        title: "N101財產申報資料審核作業(存款)-編輯查核資料",
        PreData: {},
        form: {
          category: "1",
          depositType: "",
          depositTypeText: "",
          institution: "",
          foreignSum: "",
          currency: "",
          excRate: "",
          twdSum: "",
          ownerIdn: "",
          owner: "",
        },
        dropDownList: {
          categorys: [],
          coinTypes: [],
          owners: [],
        },
        modifiedType: "",
      },
      StockModal: {
        show: false,
        title: "N101財產申報資料審核作業(有價證券股票)-編輯查核資料",
        PreData: {},
        form: {
          ownerIdn: "",
          stockCode: "",
          stockName: "",
          share: "",
          parValue: "",
          currency: "",
          excRate: "",
          twdSum: "",
        },
        dropDownList: {
          owners: [],
          coinTypes: [],
        },
        modifiedType: "",
      },
      BondValuePaperModal: {
        show: false,
        title:
          "N101財產申報資料審核作業(有價證券-票券，債券，其他有價證券)-編輯查核資料",
        PreData: {},
        form: {
          ownerIdn: "",
          owner: "",
          stockCode: "",
          stockName: "",
          share: "",
          parValue: "",
          currency: "",
          excRate: "",
          institution: "",
          twdSum: "",
        },
        dropDownList: {
          owners: [],
          coinTypes: "",
        },
        modifiedType: "",
      },
      FundModal: {
        show: false,
        title: "N101財產申報資料審核作業(有價證券基金受益憑證)-編輯查核資料",
        PreData: {},
        form: {
          ownerIdn: "",
          stockCode: "",
          stockName: "",
          share: "",
          parValue: "",
          currency: "",
          excRate: "",
          institution: "",
          twdSum: "",
        },
        dropDownList: {
          owners: [],
          coinTypes: [],
        },
        modifiedType: "",
      },
      OtherPropertyModal: {
        show: false,
        title: "N101財產申報資料審核作業(其他財產)-編輯查核資料",
        PreData: {},
        form: {},
        dropDownList: {
          owners: [],
        },
        modifiedType: "",
      },
      InsuranceModal: {
        show: false,
        isNew2: false,
        isNew: true,
        title: "N101財產申報資料審核作業(保險)-編輯查核資料",
        PreData: {},
        form: {
          companyName: "",
          companyNameText: "",
          insuranceName: "",
          ownerIdn: "",
          remark: "",
          insuranceNo: "",
          contractType: "",
          startDate: "",
          endDate: "",
          amount: "",
          currency: "",
          contractAggregatePremium: "",
          rate: "",
          contractAggregatePremiumNt: "",
        },
        dropDownList: {
          companyNames: [],
          owners: [],
          coinTypes: [],
        },
        modifiedType: "",
      },
      ClaimModal: {
        show: false,
        title: "N101財產申報資料審核作業(債權)-編輯查核資料",
        PreData: {},
        form: {
          claimsType: "",
          ownerIdn: "",
          debtorName: "",
          debtorAddr: "",
          twdSum: "",
          enterDate: "",
          enterReason: "",
        },
        dropDownList: {
          owners: [],
        },
        modifiedType: "",
      },
      DebtModal: {
        show: false,
        title: "N101財產申報資料審核作業(債務)-編輯查核資料",
        PreData: {},
        form: {
          debtType: "",
          debtTypeText: "",
          claimsName: "",
          claimsAddr: "",
          ownerIdn: "",
          twdSum: "",
          enterDate: "",
          enterReason: "",
        },
        dropDownList: {
          owners: [],
          debtTypes: [],
        },
        modifiedType: "",
      },
      InvestmentModal: {
        show: false,
        title: "N101財產申報資料審核作業(事業投資)-編輯查核資料",
        PreData: {},
        form: {
          ownerIdn: "",
          companyName: "",
          companyAddress: "",
          priceTotal: "",
          enterDate: "",
          enterReason: "",
        },
        dropDownList: {
          owners: [],
        },
        modifiedType: "",
      },
      // RemarkModal:{
      //   show: false,
      //   title: 'F201財產申報資料審核作業(備註)-新增查核資料',
      //   form:{},
      // },
      VirtualAssetsModal: {
        show: false,
        title: "N101財產申報資料審核作業(虛擬資產)-編輯查核資料",
        PreData: {},
        form: {
            virtualAssetName: "",
            owners: "",
            amount: "",
            amountUnit: "顆",
            institution: "",
			      account: "",
            enterReason: "",
            twdSum: "",
        },
        dropDownList: {
          owners: [],
        },
        modifiedType: "",
      },
      Alert: {
        enableClose: true,
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    DetailModal: VueModal,
    LandModal: VueModal,
    BuildingModal: VueModal,
    VesselModal: VueModal,
    VehicleModal: VueModal,
    AircraftModal: VueModal,
    CurrencyModal: VueModal,
    DepositModal: VueModal,
    StockModal: VueModal,
    BondValuePaperModal: VueModal,
    FundModal: VueModal,
    OtherPropertyModal: VueModal,
    InsuranceModal: VueModal,
    ClaimModal: VueModal,
    DebtModal: VueModal,
    InvestmentModal: VueModal,
    //RemarkModal: VueModal,
    VirtualAssetsModal: VueModal,
    A101DetailModal: VueModal,
    Alert: VueModal,
    DatePicker: VueDatepicker,
  },
  methods: {
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    getSyearDropDownList: function () {
      let syears = [];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //第一頁按紐查詢
    doQuery: function () {
      const self = this;
      //清空
      self.Order = "";
      self.Sort = "";
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        SYEAR: self.form.syear,
        GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
            ? self.form.jobGovCode3
            : self.form.jobGovCode2
              ? self.form.jobGovCode2
              : self.form.jobGovCode1
                ? self.form.jobGovCode1
                : "",
        GOVCHECK: self.form.jobGovCheck,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      //console.log(JSON.stringify(postData));
      F201_SearchGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "IDN";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        SYEAR: self.form.syear,
        GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
            ? self.form.jobGovCode3
            : self.form.jobGovCode2
              ? self.form.jobGovCode2
              : self.form.jobGovCode1
                ? self.form.jobGovCode1
                : "",
        GOVCHECK: self.form.jobGovCheck,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      //console.log(JSON.stringify(postData));
      F201_ReSearchGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    //第一頁按紐重填
    btnClear: function () {
      const self = this;
      self.form = {
        idn: "",
        name: "",
        syear: String(new Date().getFullYear() - 1911 - 1),
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        pagesize: 10,
        currentpage: 1,
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    //第一頁按紐列印
    btnPrint: function (data) {
      const self = this;
      let postData = {
        idn: data.idn,
        name: data.name,
        syear: data.syear,
        goV_CODE: data.goV_CODE,
        surveyDay: data.surveyDay,
        auth_SEQ: data.auth_SEQ,
        seqno: data.seqno,
        printtype: self.form.printtype,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第一頁列印",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      if (self.form.printtype == "ODT") {
        F201_printVerifyResult_Docx(postData).then((rData) => {
          let link = document.createElement("a");
          //link.download = "實質審核對照報表.docx";
          link.download = "實質審核對照報表.odt";
          // link.href = "data:application/pdf;base64," + rData;
          //link.href = "data:application/doc;base64," + rData;
          //link.href = "application/org.oasis.opendocument.text;base64," + rData;
          //link.href = rData;
          link.href = "data:application/doc;base64," + rData;
          link.click();
        });
      } else {
        F201_printVerifyResult_Docx(postData).then((rData) => {
          let link = document.createElement("a");
          link.download = "實質審核對照報表.docx";
          // link.href = "data:application/pdf;base64," + rData;
          link.href = "data:application/doc;base64," + rData;
          link.click();
        });
      }
    },
    DetailModalBtnPrint: function () {
      const self = this;
      self.btnPrint(self.DetailModal.PreData);
    },
    //第一頁審核
    btnModalShow: function (data) {
      const self = this;
      self.DetailModal.PreData = data;
      self.DetailModal.form = {};
      self.DetailModal.pagesize = 20;
      self.DetailModal.currentpage = 1;
      self.DetailModal.MenuIndex = 0;
      self.F201_SearchGrid2("Land");
      self.DetailModal.show = true;
    },
    //回溯RELOAD
    btnReloadModalShow: function (data, page) {
      const self = this;
      self.DetailModal.PreData = data;
      self.F201_SearchGrid2(page);
      self.DetailModal.show = true;
    },
    //第二頁審核比對結果內容 API
    F201_SearchGrid2: function (page) {
      const self = this;
      let data = self.DetailModal.PreData;
      //console.log(data);
      let postData = {
        IDN: data.idn,
        NAME: data.name,
        SYEAR: data.syear,
        GOV_CODE: data.goV_CODE,
        GOV_CODES: self.loginInfo.govCode,
        SurveyDay: data.surveyDay,
        Auth_SEQ: data.auth_SEQ,
        SEQNO: data.seqno,
        CURRENTPAGE: self.DetailModal.currentpage,
        PAGESIZE: self.DetailModal.pagesize,
        Page: page,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "審核",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      //console.log(postData);
      F201_SearchGrid2(postData).then((rData) => {
        //console.log(rData);
        self.DetailModal.grid = rData.returnObject;
        self.DetailModal.form = {
          name: self.DetailModal.grid ? self.DetailModal.grid.name : "",
          idn: self.DetailModal.grid ? self.DetailModal.grid.idn : "",
          dtype: self.DetailModal.grid ? self.DetailModal.grid.dtype : "",
          sdate: self.DetailModal.grid ? self.DetailModal.grid.sdate : "",
          datetime: self.DetailModal.grid ? self.DetailModal.grid.datetime : "",
        };
        //各財產
        self.DetailModal.form.Lands = self.DetailModal.grid.land;
        self.DetailModal.form.Buildings = self.DetailModal.grid.building;
        self.DetailModal.form.Vessels = self.DetailModal.grid.vessel;
        self.DetailModal.form.Vehicles = self.DetailModal.grid.vehicle;
        self.DetailModal.form.Aircrafts = self.DetailModal.grid.aircraft;
        self.DetailModal.form.Currencys = self.DetailModal.grid.currency;
        self.DetailModal.form.Deposits = self.DetailModal.grid.deposit;
        self.DetailModal.form.Stocks = self.DetailModal.grid.stock;
        self.DetailModal.form.BondValuePapers = self.DetailModal.grid.bondValuePaper;
        self.DetailModal.form.Funds = self.DetailModal.grid.fund;
        self.DetailModal.form.OtherPropertys = self.DetailModal.grid.otherProperty;
        self.DetailModal.form.Insurances = self.DetailModal.grid.insurance;
        self.DetailModal.form.Claims = self.DetailModal.grid.claim;
        self.DetailModal.form.Debts = self.DetailModal.grid.debt;
        self.DetailModal.form.Investments = self.DetailModal.grid.investment;
        self.DetailModal.form.VirtualAssets = self.DetailModal.grid.virtualAssets;

        if (parseInt(self.DetailModal.form.datetime) >= 1120901) {
          self.DetailModal.showVirtualAssets = true;
        }
        else
        {
          self.DetailModal.showVirtualAssets = false;
        }
      });
    },
    //第二頁列印不符項目
    DetailModalBtnPrintCKA: function () {
      const self = this;
      const data = self.DetailModal.PreData;
      let postData = {
        idn: data.idn,
        name: data.name,
        syear: data.syear,
        goV_CODE: data.goV_CODE,
        surveyDay: data.surveyDay,
        auth_SEQ: data.auth_SEQ,
        seqno: data.seqno,
        PRINTTYPE: self.form.printtype,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁列印不符項目",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };

      F201_printVerifyNoMatchResult_Docx(postData).then((rData) => {
        let link = document.createElement("a");
        if (self.form.printtype == "ODT") {
          link.download = "實質審核對照報表.odt";
        }
        else {
          link.download = "實質審核對照報表.docx";
        }
        link.href = "data:application/doc;base64," + rData;
        link.click();
      });
    },
    //grid
    //第二頁新增查核資料
    DetailModalbtnAdd: function () {
      const self = this;
      switch (self.DetailModal.MenuIndex) {
        case 0:
          //土地
          self.LandModal.modifiedType = "NI";
          self.LandModal.title = "N101財產申報資料審核作業(土地)-新增查核資料";
          self.DetailModalItemInit();
          self.LandModal.show = true;
          break;
        case 1:
          //建物
          self.BuildingModal.modifiedType = "NI";
          self.BuildingModal.title =
            "N101財產申報資料審核作業(建物)-新增查核資料";
          self.DetailModalItemInit();
          self.BuildingModal.show = true;
          break;
        case 2:
          //船舶
          self.VesselModal.modifiedType = "NI";
          self.VesselModal.title =
            "N101財產申報資料審核作業(船舶)-新增查核資料";
          self.DetailModalItemInit();
          self.VesselModal.show = true;
          break;
        case 3:
          //汽車
          self.VehicleModal.modifiedType = "NI";
          self.VehicleModal.title =
            "N101財產申報資料審核作業(汽車)-新增查核資料";
          self.DetailModalItemInit();
          self.VehicleModal.show = true;
          break;
        case 4:
          //航空器
          self.AircraftModal.modifiedType = "NI";
          self.AircraftModal.title =
            "N101財產申報資料審核作業(航空器)-新增查核資料";
          self.DetailModalItemInit();
          self.AircraftModal.show = true;
          break;
        case 5:
          //現金
          self.CurrencyModal.modifiedType = "NI";
          self.CurrencyModal.show = true;
          self.CurrencyModal.title =
            "N101財產申報資料審核作業(現金)-新增查核資料";
          self.DetailModalItemInit();
          self.CurrencyModal.show = true;
          break;
        case 6:
          //存款
          self.DepositModal.modifiedType = "NI";
          self.DepositModal.title =
            "N101財產申報資料審核作業(存款)-新增查核資料";
          self.DetailModalItemInit();
          self.DepositModal.show = true;
          break;
        case 7:
          //有價證券(股票)
          self.StockModal.modifiedType = "NI";
          self.StockModal.title =
            "N101財產申報資料審核作業(有價證券股票)-新增查核資料";
          self.DetailModalItemInit();
          self.StockModal.show = true;
          break;
        case 8:
          //有價證券(票券，債券，其他有價證券)
          self.BondValuePaperModal.modifiedType = "NI";
          self.BondValuePaperModal.title =
            "N101財產申報資料審核作業(有價證券-票券，債券，其他有價證券)-新增查核資料";
          self.DetailModalItemInit();
          self.BondValuePaperModal.show = true;
          break;
        case 9:
          //有價證券(基金受益憑證)
          self.FundModal.modifiedType = "NI";
          self.FundModal.title =
            "N101財產申報資料審核作業(有價證券基金受益憑證)-新增查核資料";
          self.DetailModalItemInit();
          self.FundModal.show = true;
          break;
        case 10:
          //其他財產
          self.OtherPropertyModal.modifiedType = "NI";
          self.OtherPropertyModal.title =
            "N101財產申報資料審核作業(其他財產)-新增查核資料";
          self.DetailModalItemInit();
          self.OtherPropertyModal.show = true;
          break;
        case 11:
          //保險
          self.InsuranceModal.modifiedType = "NI";
          self.InsuranceModal.title =
            "N101財產申報資料審核作業(保險)-新增查核資料";
          self.DetailModalItemInit();
          self.InsuranceModal.show = true;
          if (
            self.DetailModal.form.sdate != null ||
            self.DetailModal.form.sdate != ""
          ) {
            if (parseInt(self.DetailModal.form.sdate) >= 1120901) {
              self.InsuranceModal.isNew2 = true;
              self.InsuranceModal.isNew = false;
            }
            else if (parseInt(self.DetailModal.form.sdate) >= 1100308) {
              self.InsuranceModal.isNew2 = false;
              self.InsuranceModal.isNew = true;
            } else {
              self.InsuranceModal.isNew2 = false;
              self.InsuranceModal.isNew = false;
            }
          }
          break;
        case 12:
          //債權
          self.ClaimModal.modifiedType = "NI";
          self.ClaimModal.title = "N101財產申報資料審核作業(債權)-新增查核資料";
          self.DetailModalItemInit();
          self.ClaimModal.show = true;
          break;
        case 13:
          //債務
          self.DebtModal.modifiedType = "NI";
          self.DebtModal.title = "N101財產申報資料審核作業(債務)-新增查核資料";
          self.DetailModalItemInit();
          self.DebtModal.show = true;
          break;
        case 14:
          //事業投資
          self.InvestmentModal.modifiedType = "NI";
          self.InvestmentModal.title =
            "N101財產申報資料審核作業(事業投資)-新增查核資料";
          self.DetailModalItemInit();
          self.InvestmentModal.show = true;
          break;
        // case 15:
        //   //備註
        //   self.RemarkModal.show = true;
        //   break;
        case 16:
          //虛擬資產
          self.VirtualAssetsModal.modifiedType = "NI";
          self.VirtualAssetsModal.title =
            "N101財產申報資料審核作業(虛擬資產)-新增查核資料";
          self.DetailModalItemInit();
          self.VirtualAssetsModal.show = true;
          break;
      }
    },
    //第二頁新增
    DetailModalBtnItemAdd: function (data) {
      const self = this;
      switch (self.DetailModal.MenuIndex) {
        case 0:
          //土地
          self.LandModal.PreData = data;
          self.LandModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(土地)-新增查核資料"
              : "N101財產申報資料審核作業(土地)-編輯查核資料";
          self.DetailModalItemInit();
          self.LandModal.show = true;
          break;
        case 1:
          //建物
          self.BuildingModal.PreData = data;
          self.BuildingModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(建物)-新增查核資料"
              : "N101財產申報資料審核作業(建物)-編輯查核資料";
          self.DetailModalItemInit();
          self.BuildingModal.show = true;
          break;
        case 2:
          //船舶
          self.VesselModal.PreData = data;
          self.VesselModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(船舶)-新增查核資料"
              : "N101財產申報資料審核作業(船舶)-編輯查核資料";
          self.DetailModalItemInit();
          self.VesselModal.show = true;
          break;
        case 3:
          //汽車
          self.VehicleModal.PreData = data;
          self.VehicleModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(汽車)-新增查核資料"
              : "N101財產申報資料審核作業(汽車)-編輯查核資料";
          self.DetailModalItemInit();
          self.VehicleModal.show = true;
          break;
        case 4:
          //航空器
          self.AircraftModal.PreData = data;
          self.AircraftModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(航空器)-新增查核資料"
              : "N101財產申報資料審核作業(航空器)-編輯查核資料";
          self.DetailModalItemInit();
          self.AircraftModal.show = true;
          break;
        case 5:
          //現金
          self.CurrencyModal.PreData = data;
          self.CurrencyModal.modifiedType = "I";
          self.CurrencyModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(現金)-新增查核資料"
              : "N101財產申報資料審核作業(現金)-編輯查核資料";
          self.DetailModalItemInit();
          self.CurrencyModal.show = true;
          break;
        case 6:
          //存款
          self.DepositModal.PreData = data;
          self.DepositModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(存款)-新增查核資料"
              : "N101財產申報資料審核作業(存款)-編輯查核資料";
          self.DetailModalItemInit();
          self.DepositModal.show = true;
          break;
        case 7:
          //有價證券(股票)
          self.StockModal.PreData = data;
          self.StockModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(有價證券股票)-新增查核資料"
              : "N101財產申報資料審核作業(有價證券股票)-編輯查核資料";
          self.DetailModalItemInit();
          self.StockModal.show = true;
          break;
        case 8:
          //有價證券(票券，債券，其他有價證券)
          self.BondValuePaperModal.PreData = data;
          self.BondValuePaperModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(有價證券-票券，債券，其他有價證券)-新增查核資料"
              : "N101財產申報資料審核作業(有價證券-票券，債券，其他有價證券)-編輯查核資料";
          self.DetailModalItemInit();
          self.BondValuePaperModal.show = true;
          break;
        case 9:
          //有價證券(基金受益憑證)
          self.FundModal.PreData = data;
          self.FundModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(有價證券基金受益憑證)-新增查核資料"
              : "N101財產申報資料審核作業(有價證券基金受益憑證)-編輯查核資料";
          self.DetailModalItemInit();
          self.FundModal.show = true;
          break;
        case 10:
          //其他財產
          self.OtherPropertyModal.PreData = data;
          self.OtherPropertyModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(有其他財產)-新增查核資料"
              : "N101財產申報資料審核作業(有其他財產)-編輯查核資料";
          self.DetailModalItemInit();
          self.OtherPropertyModal.show = true;
          break;
        case 11:
          //保險
          self.InsuranceModal.PreData = data;
          self.InsuranceModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(保險)-新增查核資料"
              : "N101財產申報資料審核作業(保險)-編輯查核資料";
          self.DetailModalItemInit();
          self.InsuranceModal.show = true;
          if (
            self.DetailModal.form.sdate != null ||
            self.DetailModal.form.sdate != ""
          ) {
            if (parseInt(self.DetailModal.form.datetime) >= 1120901) {
              self.InsuranceModal.isNew2 = true;
              self.InsuranceModal.isNew = false;
            }
            else if (parseInt(self.DetailModal.form.datetime) >= 1100308) {
              self.InsuranceModal.isNew2 = false;
              self.InsuranceModal.isNew = true;
            } else {
              self.InsuranceModal.isNew2 = false;
              self.InsuranceModal.isNew = false;
            }
          }
          break;
        case 12:
          //債權
          self.ClaimModal.PreData = data;
          self.ClaimModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(債權)-新增查核資料"
              : "N101財產申報資料審核作業(債權)-編輯查核資料";
          self.DetailModalItemInit();
          self.ClaimModal.show = true;
          break;
        case 13:
          //債務
          self.DebtModal.PreData = data;
          self.DebtModal.modifiedType = "I";
          self.DebtModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(債務)-新增查核資料"
              : "N101財產申報資料審核作業(債務)-編輯查核資料";
          self.DetailModalItemInit();
          self.DebtModal.show = true;
          break;
        case 14:
          //事業投資
          self.InvestmentModal.PreData = data;
          self.InvestmentModal.modifiedType = "I";
          self.InvestmentModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(事業投資)-新增查核資料"
              : "N101財產申報資料審核作業(事業投資)-編輯查核資料";
          self.DetailModalItemInit();
          self.InvestmentModal.show = true;
          break;
        // case 15:
        //   //備註
        //   self.RemarkModal.show = true;
        //   break;
        case 16:
          //虛擬資產
          self.VirtualAssetsModal.PreData = data;
          self.VirtualAssetsModal.modifiedType = "I";
          self.VirtualAssetsModal.title =
            !data.hasData && data.kind != "2"
              ? "N101財產申報資料審核作業(虛擬資產)-新增查核資料"
              : "N101財產申報資料審核作業(虛擬資產)-編輯查核資料";
          self.DetailModalItemInit();
          self.VirtualAssetsModal.show = true;
          break;
      }
    },
    //第二頁編
    DetailModalBtnItemEdit: function (data) {
      const self = this;
      let ObjList = [];
      switch (self.DetailModal.MenuIndex) {
        case 0:
          //土地
          self.LandModal.PreData = data;
          ObjList = self.DetailModal.form.Lands;
          let postData0 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData0,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201土地-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.LandModal.PreData.data = rData.returnObject;
              self.LandModal.modifiedType = "U";
              self.LandModal.title =
                "N101財產申報資料審核作業(土地)-編輯查核資料";
              self.DetailModalItemInit();
              self.LandModal.show = true;
            }
          });
          break;
        case 1:
          //建物
          self.BuildingModal.PreData = data;
          ObjList = self.DetailModal.form.Buildings;
          let postData1 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData1,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201建物-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.BuildingModal.PreData.data = rData.returnObject;
              self.BuildingModal.modifiedType = "U";
              self.BuildingModal.title =
                "N101財產申報資料審核作業(建物)-編輯查核資料";
              self.DetailModalItemInit();
              self.BuildingModal.show = true;
            }
          });
          break;
        case 2:
          //船舶
          self.VesselModal.PreData = data;
          ObjList = self.DetailModal.form.Vessels;
          let postData2 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData2,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201船舶-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.VesselModal.PreData.data = rData.returnObject;
              self.VesselModal.modifiedType = "U";
              self.VesselModal.title =
                "N101財產申報資料審核作業(船舶)-編輯查核資料";
              self.DetailModalItemInit();
              self.VesselModal.show = true;
            }
          });
          break;
        case 3:
          //汽車
          self.VehicleModal.PreData = data;
          ObjList = self.DetailModal.form.Vehicles;
          let postData3 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData3,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201汽車-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.VehicleModal.PreData.data = rData.returnObject;
              self.VehicleModal.modifiedType = "U";
              self.VehicleModal.title =
                "N101財產申報資料審核作業(汽車)-編輯查核資料";
              self.DetailModalItemInit();
              self.VehicleModal.show = true;
            }
          });
          break;
        case 4:
          //航空器
          self.AircraftModal.PreData = data;
          ObjList = self.DetailModal.form.Aircrafts;
          let postData4 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData4,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201航空器-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.AircraftModal.PreData.data = rData.returnObject;
              self.AircraftModal.modifiedType = "U";
              self.AircraftModal.title =
                "N101財產申報資料審核作業(航空器)-編輯查核資料";
              self.DetailModalItemInit();
              self.AircraftModal.show = true;
            }
          });
          break;
        case 5:
          //現金
          self.CurrencyModal.PreData = data;
          ObjList = self.DetailModal.form.currency;
          let postData5 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData5,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201現金-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.CurrencyModal.PreData.data = rData.returnObject;
              self.CurrencyModal.modifiedType = "U";
              self.CurrencyModal.title =
                "N101財產申報資料審核作業(現金)-編輯查核資料";
              self.DetailModalItemInit();
              self.CurrencyModal.show = true;
            }
          });
          break;
        case 6:
          //存款
          self.DepositModal.PreData = data;
          ObjList = self.DetailModal.form.Deposits;
          let postData6 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData6,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201存款-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.DepositModal.PreData.data = rData.returnObject;
              self.DepositModal.modifiedType = "U";
              self.DepositModal.title =
                "N101財產申報資料審核作業(存款)-編輯查核資料";
              self.DetailModalItemInit();
              self.DepositModal.show = true;
            }
          });
          break;
        case 7:
          //有價證券(股票)
          self.StockModal.PreData = data;
          ObjList = self.DetailModal.form.Stocks;
          let postData7 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData7,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201有價證券(股票)-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.StockModal.PreData.data = rData.returnObject;
              self.StockModal.modifiedType = "U";
              self.StockModal.title =
                "N101財產申報資料審核作業(有價證券股票)-編輯查核資料";
              self.DetailModalItemInit();
              self.StockModal.show = true;
            }
          });
          break;
        case 8:
          //有價證券(票券，債券，其他有價證券)
          self.BondValuePaperModal.PreData = data;
          ObjList = self.DetailModal.form.BondValuePapers;
          let postData8 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData8,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201有價證券(票券，債券，其他有價證券)-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.BondValuePaperModal.PreData.data = rData.returnObject;
              self.BondValuePaperModal.modifiedType = "U";
              self.BondValuePaperModal.title =
                "N101財產申報資料審核作業(有價證券-票券，債券，其他有價證券)-編輯查核資料";
              self.DetailModalItemInit();
              self.BondValuePaperModal.show = true;
            }
          });
          break;
        case 9:
          //有價證券(基金受益憑證)
          self.FundModal.PreData = data;
          ObjList = self.DetailModal.form.Funds;
          let postData9 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData9,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201有價證券(基金受益憑證)-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.FundModal.PreData.data = rData.returnObject;
              self.FundModal.modifiedType = "U";
              self.FundModal.title =
                "N101財產申報資料審核作業(有價證券基金受益憑證)-編輯查核資料";
              self.DetailModalItemInit();
              self.FundModal.show = true;
            }
          });
          break;
        case 10:
          //其他財產
          self.OtherPropertyModal.PreData = data;
          ObjList = self.DetailModal.form.OtherPropertys;
          let postData10 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData10,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201其他財產-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.OtherPropertyModal.PreData.data = rData.returnObject;
              self.OtherPropertyModal.modifiedType = "U";
              self.OtherPropertyModal.title =
                "N101財產申報資料審核作業(有其他財產)-編輯查核資料";
              self.DetailModalItemInit();
              self.OtherPropertyModal.show = true;
            }
          });
          break;
        case 11:
          //保險
          self.InsuranceModal.PreData = data;
          ObjList = self.DetailModal.form.Insurances;
          let postData11 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData11,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201保險-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.InsuranceModal.PreData.data = rData.returnObject;
              self.InsuranceModal.modifiedType = "U";
              self.InsuranceModal.title =
                "N101財產申報資料審核作業(保險)-編輯查核資料";
              self.DetailModalItemInit();
              self.InsuranceModal.show = true;
              if (
                self.DetailModal.form.datetime != null ||
                self.DetailModal.form.datetime != ""
              ) {
                if (parseInt(self.DetailModal.form.datetime) >= 1120901) {
                  self.InsuranceModal.isNew2 = true;
                  self.InsuranceModal.isNew = false;
                }
                else if (parseInt(self.DetailModal.form.datetime) >= 1100308) {
                  self.InsuranceModal.isNew2 = false;
                  self.InsuranceModal.isNew = true;
                } else {
                  self.InsuranceModal.isNew2 = false;
                  self.InsuranceModal.isNew = false;
                }
              }
            }
          });
          break;
        case 12:
          //債權
          self.ClaimModal.PreData = data;
          ObjList = self.DetailModal.form.Claims;
          let postData12 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData12,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201債權-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.ClaimModal.PreData.data = rData.returnObject;
              self.ClaimModal.modifiedType = "U";
              self.ClaimModal.title =
                "N101財產申報資料審核作業(債權)-編輯查核資料";
              self.DetailModalItemInit();
              self.ClaimModal.show = true;
            }
          });
          break;
        case 13:
          //債務
          self.DebtModal.PreData = data;
          ObjList = self.DetailModal.form.Debts;
          let postData13 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData13,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201債務-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.DebtModal.PreData.data = rData.returnObject;
              self.DebtModal.modifiedType = "U";
              self.DebtModal.title =
                "N101財產申報資料審核作業(債務)-編輯查核資料";
              self.DetailModalItemInit();
              self.DebtModal.show = true;
            }
          });
          break;
        case 14:
          //事業投資
          self.InvestmentModal.PreData = data;
          ObjList = self.DetailModal.form.Investments;
          let postData14 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData14,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201事業投資-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.InvestmentModal.PreData.data = rData.returnObject;
              self.InvestmentModal.modifiedType = "U";
              self.InvestmentModal.title =
                "N101財產申報資料審核作業(事業投資)-編輯查核資料";
              self.DetailModalItemInit();
              self.InvestmentModal.show = true;
            }
          });
          break;
        // case 15:
        //   //備註
        //   self.RemarkModal.show = true;
        //   break;
        case 16:
          //虛擬資產
          self.VirtualAssetsModal.PreData = data;
          ObjList = self.DetailModal.form.VirtualAssets;
          let postData16 = [
            {
              verifySeq: data.verifySeq,
              detailSeq: data.detailSeq,
            },
          ];
          F201_searchText2Object({
            data: postData16,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "F201虛擬資產-編",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          }).then((rData) => {
            if (rData.result) {
              self.VirtualAssetsModal.PreData.data = rData.returnObject;
              self.VirtualAssetsModal.modifiedType = "U";
              self.VirtualAssetsModal.title =
                "N101財產申報資料審核作業(虛擬資產)-編輯查核資料";
              self.DetailModalItemInit();
              self.VirtualAssetsModal.show = true;
            }
          });
          break;
      }
    },
    //第二頁配對
    DetailModalBtnItemMate: function (data) {
      const self = this;
      let ObjList = [];
      var tableName = "";
      switch (self.DetailModal.MenuIndex) {
        case 0:
          //土地
          tableName = "Land";
          ObjList = self.DetailModal.form.Lands;
          break;
        case 1:
          //建物
          tableName = "Building";
          ObjList = self.DetailModal.form.Buildings;
          break;
        case 2:
          //船舶
          tableName = "Vessel";
          ObjList = self.DetailModal.form.Vessels;
          break;
        case 3:
          //汽車
          tableName = "Vehicle";
          ObjList = self.DetailModal.form.Vehicles;
          break;
        case 4:
          //航空器
          tableName = "Aircraft";
          ObjList = self.DetailModal.form.Aircrafts;
          break;
        case 5:
          //現金
          tableName = "FCurrency";
          ObjList = self.DetailModal.form.Currencys;
          break;
        case 6:
          //存款
          tableName = "Deposit";
          ObjList = self.DetailModal.form.Deposits;
          break;
        case 7:
          //有價證券(股票)
          tableName = "StocknBond_1";
          ObjList = self.DetailModal.form.Stocks;
          break;
        case 8:
          //有價證券(票券，債券，其他有價證券)
          tableName = "StocknBond_2";
          ObjList = self.DetailModal.form.BondValuePapers;
          break;
        case 9:
          //有價證券(基金受益憑證)
          tableName = "StocknBond_3";
          ObjList = self.DetailModal.form.Funds;
          break;
        case 10:
          //其他財產
          tableName = "Misc";
          ObjList = self.DetailModal.form.OtherPropertys;
          break;
        case 11:
          //保險
          tableName = "Insurance";
          ObjList = self.DetailModal.form.Insurances;
          break;
        case 12:
          //債權
          tableName = "Credit";
          ObjList = self.DetailModal.form.Claims;
          break;
        case 13:
          //債務
          tableName = "Debit";
          ObjList = self.DetailModal.form.Debts;
          break;
        case 14:
          //事業投資
          tableName = "Investment";
          ObjList = self.DetailModal.form.Investments;
          break;
        // case 15:
        //   //備註
        //   break;
        case 16:
          //虛擬資產
          tableName = "VirtualAssets";
          ObjList = self.DetailModal.form.VirtualAssets;
          break;
      }
      let verify = ObjList.map((item) => ({
        verifySeq: item.verifySeq,
        detailSeq: item.detailSeq,
        verifyNote: item.verifyNote,
        verifyStatus: item.verifyStatus,
      }));
      let postData = {
        seqno: self.DetailModal.PreData.seqno,
        verifySeq: verify[0].verifySeq,
        detailSeqMatch: parseInt(data.seq),
        detailSeqOriginal: data.detailSeq,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "配對",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      //console.log(JSON.stringify(postData));
      F201_matchVerifyResult(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["配對成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.F201_SearchGrid2(tableName);
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["配對失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁回溯原查核資料
    DetailModalbtnRe: function (MenuIndex) {
      const self = this;
      var tableName = "";
      switch (MenuIndex) {
        case 0:
          //土地
          tableName = "Land";
          break;
        case 1:
          //建物
          tableName = "Building";
          break;
        case 2:
          //船舶
          tableName = "Vessel";
          break;
        case 3:
          //汽車
          tableName = "Vehicle";
          break;
        case 4:
          //航空器
          tableName = "Aircraft";
          break;
        case 5:
          //現金
          tableName = "FCurrency";
          break;
        case 6:
          //存款
          tableName = "Deposit";
          break;
        case 7:
          //有價證券(股票)
          tableName = "StocknBond_1";
          break;
        case 8:
          //有價證券(票券，債券，其他有價證券)
          tableName = "StocknBond_2";
          break;
        case 9:
          //有價證券(基金受益憑證)
          tableName = "StocknBond_3";
          break;
        case 10:
          //其他財產
          tableName = "Misc";
          break;
        case 11:
          //保險
          tableName = "Insurance";
          break;
        case 12:
          //債權
          tableName = "Credit";
          break;
        case 13:
          //債務
          tableName = "Debit";
          break;
        case 14:
          //事業投資
          tableName = "Investment";
          break;
        // case 15:
        //   //備註
        //   break;
        case 16:
          //事業投資
          tableName = "VirtualAssets";
          break;
      }
      let data = self.DetailModal.PreData;
      let postData = {
        Auth_SEQ: data.auth_SEQ,
        SEQNO: data.seqno,
        verifySeq: self.DetailModal.grid.verifySeq,
        tableName: tableName,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "回溯",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      F201_mappingData(postData).then((rData) => {
        //var msg = [];
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          //msg.push(modifyObj.alertMsg)
          self.Alert.txt = ["回溯成功"];
          self.Alert.BtnConfirm = () => {
            self.btnReloadModalShow(self.DetailModal.PreData, tableName);
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          //msg.push("ModifyM1012API錯誤");
          self.Alert.txt = ["回溯失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁存檔
    DetailModalbtnSave: function () {
      const self = this;
      let ObjList = [];
      var tableName = "";
      switch (self.DetailModal.MenuIndex) {
        case 0:
          //土地
          tableName = "Land";
          ObjList = self.DetailModal.form.Lands;
          break;
        case 1:
          //建物
          tableName = "Building";
          ObjList = self.DetailModal.form.Buildings;
          break;
        case 2:
          //船舶
          tableName = "Vessel";
          ObjList = self.DetailModal.form.Vessels;
          break;
        case 3:
          //汽車
          tableName = "Vehicle";
          ObjList = self.DetailModal.form.Vehicles;
          break;
        case 4:
          //航空器
          tableName = "Aircraft";
          ObjList = self.DetailModal.form.Aircrafts;
          break;
        case 5:
          //現金
          tableName = "FCurrency";
          ObjList = self.DetailModal.form.Currencys;
          break;
        case 6:
          //存款
          tableName = "Deposit";
          ObjList = self.DetailModal.form.Deposits;
          break;
        case 7:
          //有價證券(股票)
          tableName = "StocknBond_1";
          ObjList = self.DetailModal.form.Stocks;
          break;
        case 8:
          //有價證券(票券，債券，其他有價證券)
          tableName = "StocknBond_2";
          ObjList = self.DetailModal.form.BondValuePapers;
          break;
        case 9:
          //有價證券(基金受益憑證)
          tableName = "StocknBond_3";
          ObjList = self.DetailModal.form.Funds;
          break;
        case 10:
          //其他財產
          tableName = "Misc";
          ObjList = self.DetailModal.form.OtherPropertys;
          break;
        case 11:
          //保險
          tableName = "Insurance";
          ObjList = self.DetailModal.form.Insurances;
          break;
        case 12:
          //債權
          tableName = "Credit";
          ObjList = self.DetailModal.form.Claims;
          break;
        case 13:
          //債務
          tableName = "Debit";
          ObjList = self.DetailModal.form.Debts;
          break;
        case 14:
          //事業投資
          tableName = "Investment";
          ObjList = self.DetailModal.form.Investments;
          break;
        // case 15:
        //   //備註
        //   break;
        case 16:
          //虛擬資產
          tableName = "VirtualAssets";
          ObjList = self.DetailModal.form.VirtualAssets;
          break;
      }

      let postData = ObjList.map((item) => ({
        tableName: tableName,
        verifySeq: item.verifySeq,
        detailSeq: item.detailSeq,
        verifyNote: item.verifyNote,
        verifyStatus: item.verifyStatus,
      }));
      F201_updateVerifyResult({
        data: postData,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "審核結果存檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        debugger;
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["存檔完成"];
          self.Alert.BtnConfirm = () => {
            self.F201_SearchGrid2(tableName);
            self.Alert.show = false;
            switch (self.DetailModal.MenuIndex) {
              case 0:
                //土地
                self.LandModal.show = false;
                break;
              case 1:
                //建物
                self.BuildingModal.show = false;
                break;
              case 2:
                //船舶
                self.VesselModal.show = false;
                break;
              case 3:
                //汽車
                self.VehicleModal.show = false;
                break;
              case 4:
                //航空器
                self.AircraftModal.show = false;
                break;
              case 5:
                //現金
                self.CurrencyModal.show = false;
                break;
              case 6:
                //存款
                self.DepositModal.show = false;
                break;
              case 7:
                //有價證券(股票)
                self.StockModal.show = false;
                break;
              case 8:
                //有價證券(票券，債券，其他有價證券)
                self.BondValuePaperModal.show = false;
                break;
              case 9:
                //有價證券(基金受益憑證)
                self.FundModal.show = false;
                break;
              case 10:
                //其他財產
                self.OtherPropertyModal.show = false;
                break;
              case 11:
                //保險
                self.InsuranceModal.show = false;
                break;
              case 12:
                //債權
                self.ClaimModal.show = false;
                break;
              case 13:
                //債務
                self.DebtModal.show = false;
                break;
              case 14:
                //事業投資
                self.InvestmentModal.show = false;
                break;
              // case 15:
              //   //備註
              //   break;
              case 16:
                //虛擬資產
                self.VirtualAssetsModal.show = false;
                break;
            }
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["存檔失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    /**** 下拉API ****/
    getOwners: function () {
      const self = this;
      return self.DetailModal.grid.families.map((x) => ({
        idnOrPassportno: x.idn !== "" ? x.idn : x.passportno,
        name: x.name,
      }));
    },
    //第三頁各財產init
    DetailModalItemInit: function () {
      const self = this;
      switch (self.DetailModal.MenuIndex) {
        case 0:
          //土地
          self.DetailModalItemBtnClear();
          GetLandDropDownMenu({}).then((rData) => {
            self.LandModal.dropDownList = {
              owners: self.getOwners(),
              enterReasons: rData.returnObject.enterReason,
            };
            if (self.LandModal.modifiedType === "U") {
              let data = self.LandModal.PreData.data;
              if (typeof data.enterReasonText == "undefined") {
                let enterReasonArray =
                  self.LandModal.dropDownList.enterReasons.filter(
                    (e) => e.mvalue == data.enterReason
                  );
                if (enterReasonArray.length) {
                  data.enterReason = enterReasonArray[0].mcode;
                  data.enterReasonText = "";
                } else {
                  data.enterReasonText = data.enterReason;
                  data.enterReason = "999";
                }
              }
              let matchIdn = self.LandModal.dropDownList.owners.filter(
                (o) => o.name == data.owner
              );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";

              self.LandModal.form = data;
            }
          });
          break;
        case 1:
          //建物
          GetBuildingDropDownMenu({}).then((returnData) => {
            self.BuildingModal.dropDownList = {
              owners: self.getOwners(),
              enterReasons: returnData.returnObject.enterReason,
            };
            self.DetailModalItemBtnClear();
            if (self.BuildingModal.modifiedType === "U") {
              let data = self.BuildingModal.PreData.data;
              if (typeof data.enterReasonText == "undefined") {
                let enterReasonArray =
                  self.BuildingModal.dropDownList.enterReasons.filter(
                    (e) => e.mvalue == data.enterReason
                  );
                if (enterReasonArray.length) {
                  data.enterReason = enterReasonArray[0].mcode;
                  data.enterReasonText = "";
                } else {
                  data.enterReasonText = data.enterReason;
                  data.enterReason = "999";
                }
              }
              let matchIdn = self.BuildingModal.dropDownList.owners.filter(
                (o) => o.name == data.owner
              );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";
              self.BuildingModal.form = data;
            }
          });

          break;
        case 2:
          //船舶
          GetVesselDropDownMenu({}).then((returnData) => {
            self.VesselModal.dropDownList = {
              vesselTypes: returnData.returnObject.vesselType,
              owners: self.getOwners(),
              enterReasons: returnData.returnObject.enterReason,
            };

            self.DetailModalItemBtnClear();
            if (self.VesselModal.modifiedType === "U") {
              let data = self.VesselModal.PreData.data;
              if (typeof data.vesselTypeText == "undefined") {
                let vesselTypeArray =
                  self.VesselModal.dropDownList.vesselTypes.filter(
                    (e) => e.mvalue == data.vesselType
                  );
                if (vesselTypeArray.length) {
                  data.vesselType = vesselTypeArray[0].mcode;
                  data.vesselTypeText = "";
                } else {
                  data.vesselTypeText = data.vesselType;
                  data.vesselType = "999";
                }
              }
              if (typeof data.enterReasonText == "undefined") {
                let enterReasonArray =
                  self.VesselModal.dropDownList.enterReasons.filter(
                    (e) => e.mvalue == data.enterReason
                  );
                if (enterReasonArray.length) {
                  data.enterReason = enterReasonArray[0].mcode;
                  data.enterReasonText = "";
                } else {
                  data.enterReasonText = data.enterReason;
                  data.enterReason = "999";
                }
              }

              let matchIdn = self.VesselModal.dropDownList.owners.filter(
                (o) => o.name == data.owner
              );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";
              self.VesselModal.form = data;
            }
          });

          break;
        case 3:
          //汽車
          GetVehicleDropDownMenu({}).then((returnData) => {
            self.VehicleModal.dropDownList = {
              vehicleTypes: returnData.returnObject.vehicleType,
              enterReasons: returnData.returnObject.enterReason,
              owners: self.getOwners(),
            };
            self.DetailModalItemBtnClear();
            if (self.VehicleModal.modifiedType === "U") {
              let data = self.VehicleModal.PreData.data;
              if (typeof data.vehicleTypeText == "undefined") {
                let vehicleTypes =
                  self.VehicleModal.dropDownList.vehicleTypes.filter(
                    (e) => e.mvalue == data.vehicleType
                  );
                if (vehicleTypes.length) {
                  data.vehicleType = vehicleTypes[0].mcode;
                  data.vehicleTypeText = "";
                } else {
                  data.vehicleTypeText = data.vehicleType;
                  data.vehicleType = "999";
                }
              }
              if (typeof data.enterReasonText == "undefined") {
                let enterReasonArray =
                  self.VehicleModal.dropDownList.enterReasons.filter(
                    (e) => e.mvalue == data.enterReason
                  );
                if (enterReasonArray.length) {
                  data.enterReason = enterReasonArray[0].mcode;
                  data.enterReasonText = "";
                } else {
                  data.enterReasonText = data.enterReason;
                  data.enterReason = "999";
                }
              }
              let matchIdn = self.VehicleModal.dropDownList.owners.filter(
                (o) => o.name == data.owner
              );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";
              self.VehicleModal.form = data;
            }
          });

          break;
        case 4:
          //航空器
          GetAircraftDropDownMenu({}).then((returnData) => {
            self.AircraftModal.dropDownList = {
              enterReasons: returnData.returnObject.enterReason,
              owners: self.getOwners(),
            };
            self.DetailModalItemBtnClear();
            if (self.AircraftModal.modifiedType === "U") {
              let data = self.AircraftModal.PreData.data;
              if (typeof data.enterReasonText == "undefined") {
                let enterReasonArray =
                  self.AircraftModal.dropDownList.enterReasons.filter(
                    (e) => e.mvalue == data.enterReason
                  );
                if (enterReasonArray.length) {
                  data.enterReason = enterReasonArray[0].mcode;
                  data.enterReasonText = "";
                } else {
                  data.enterReasonText = data.enterReason;
                  data.enterReason = "999";
                }
              }
              let matchIdn = self.AircraftModal.dropDownList.owners.filter(
                (o) => o.name == data.owner
              );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";
              self.AircraftModal.form = data;
            }
          });

          break;
        case 5:
          //現金
          GetCurrencyDropDownMenu({}).then((returnData) => {
            self.CurrencyModal.dropDownList = {
              coinTypes: returnData.returnObject.coinType,
              owners: self.getOwners(),
            };
            self.DetailModalItemBtnClear();
            if (self.CurrencyModal.modifiedType === "U") {
              let data = self.CurrencyModal.PreData.data;
              if (!data.mapCurrency) {
                let currency = self.CurrencyModal.dropDownList.coinTypes.filter(
                  (e) => e.mvalue == data.currency
                );
                if (currency.length) {
                  data.mapCurrency = true;
                  data.currency = currency[0].mcode;
                } else {
                  data.mapCurrency = true;
                  data.currency = "";
                }
              }
              let matchIdn = self.CurrencyModal.dropDownList.owners.filter(
                (o) => o.name == data.owner
              );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";
              self.CurrencyModal.form = data;
            }
          });
          break;
        case 6:
          //存款
          GetDepositDropDownMenu({}).then((returnData) => {
            self.DepositModal.dropDownList = {
              categorys: returnData.returnObject.category,
              coinTypes: returnData.returnObject.coinType,
              owners: self.getOwners(),
            };
            self.DetailModalItemBtnClear();
            if (self.DepositModal.modifiedType === "U") {
              let data = self.DepositModal.PreData.data;
              if (typeof data.depositTypeText == "undefined") {
                let depositTypes =
                  self.DepositModal.dropDownList.categorys.filter(
                    (e) => e.mvalue == data.depositType
                  );
                if (depositTypes.length) {
                  data.depositType = depositTypes[0].mcode;
                  data.depositTypeText = "";
                } else {
                  data.depositTypeText = data.depositType;
                  data.depositType = "999";
                }
              }
              if (!data.mapCurrency) {
                let currency = self.DepositModal.dropDownList.coinTypes.filter(
                  (e) => e.mvalue == data.currency
                );
                if (currency.length) {
                  data.mapCurrency = true;
                  data.currency = currency[0].mcode;
                } else {
                  data.mapCurrency = true;
                  data.currency = "";
                }
              }
              let matchIdn = self.DepositModal.dropDownList.owners.filter(
                (o) => o.name == data.owner
              );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";
              self.DepositModal.form = data;
            }
          });

          break;
        case 7:
          //有價證券(股票)
          GetSecuritiesDropDownMenu({}).then((returnData) => {
            self.StockModal.dropDownList = {
              coinTypes: returnData.returnObject.coinType,
              owners: self.getOwners(),
            };
            self.DetailModalItemBtnClear();
            if (self.StockModal.modifiedType === "U") {
              let data = self.StockModal.PreData.data;
              if (!data.mapCurrency) {
                let currency = self.StockModal.dropDownList.coinTypes.filter(
                  (e) => e.mvalue == data.currency
                );
                if (currency.length) {
                  data.mapCurrency = true;
                  data.currency = currency[0].mcode;
                } else {
                  data.mapCurrency = true;
                  data.currency = "";
                }
              }
              let matchIdn = self.StockModal.dropDownList.owners.filter(
                (o) => o.name == data.owner
              );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";
              self.StockModal.form = data;
            }
          });

          break;
        case 8:
          //有價證券(票券，債券，其他有價證券)
          GetSecuritiesDropDownMenu({}).then((returnData) => {
            self.BondValuePaperModal.dropDownList = {
              coinTypes: returnData.returnObject.coinType,
              owners: self.getOwners(),
            };
            self.DetailModalItemBtnClear();
            if (self.BondValuePaperModal.modifiedType === "U") {
              let data = self.BondValuePaperModal.PreData.data;
              if (!data.mapCurrency) {
                let currency =
                  self.BondValuePaperModal.dropDownList.coinTypes.filter(
                    (e) => e.mvalue == data.currency
                  );
                if (currency.length) {
                  data.mapCurrency = true;
                  data.currency = currency[0].mcode;
                } else {
                  data.mapCurrency = true;
                  data.currency = "";
                }
              }
              let matchIdn =
                self.BondValuePaperModal.dropDownList.owners.filter(
                  (o) => o.name == data.owner
                );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";
              self.BondValuePaperModal.form = data;
            }
          });

          break;
        case 9:
          //有價證券(基金受益憑證)
          GetSecuritiesDropDownMenu({}).then((returnData) => {
            self.FundModal.dropDownList = {
              coinTypes: returnData.returnObject.coinType,
              owners: self.getOwners(),
            };
            self.DetailModalItemBtnClear();
            if (self.FundModal.modifiedType === "U") {
              let data = self.FundModal.PreData.data;
              if (!data.mapCurrency) {
                let currency = self.FundModal.dropDownList.coinTypes.filter(
                  (e) => e.mvalue == data.currency
                );
                if (currency.length) {
                  data.mapCurrency = true;
                  data.currency = currency[0].mcode;
                } else {
                  data.mapCurrency = true;
                  data.currency = "";
                }
              }
              let matchIdn = self.FundModal.dropDownList.owners.filter(
                (o) => o.name == data.owner
              );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";
              self.FundModal.form = data;
            }
          });

          break;
        case 10:
          //其他財產
          self.OtherPropertyModal.dropDownList = {
            owners: self.getOwners(),
          };
          self.DetailModalItemBtnClear();
          if (self.OtherPropertyModal.modifiedType === "U") {
            let data = self.OtherPropertyModal.PreData.data;
            let matchIdn = self.OtherPropertyModal.dropDownList.owners.filter(
              (o) => o.name == data.owner
            );
            data.ownerIdn = matchIdn.length ? matchIdn[0].idnOrPassportno : "";
            self.OtherPropertyModal.form = data;
          }
          break;
        case 11:
          //保險
          GetInsuranceDropDownMenu({}).then((returnData) => {
            self.InsuranceModal.dropDownList = {
              owners: self.getOwners(),
              companyNames: returnData.returnObject.companyNames,
              coinTypes: returnData.returnObject.coinTypes,
            };
            self.DetailModalItemBtnClear();
            if (self.InsuranceModal.modifiedType === "U") {
              let data = self.InsuranceModal.PreData.data;
              if (typeof data.companyNameText == "undefined") {
                let companyNames =
                  self.InsuranceModal.dropDownList.companyNames.filter(
                    (e) => e.mvalue == data.companyName
                  );
                if (companyNames.length) {
                  data.companyName = companyNames[0].mcode;
                  data.companyNameText = "";
                } else {
                  data.companyNameText = data.companyName;
                  data.companyName = "999";
                }
              }
              if (!data.mapCurrency) {
                let currency =
                  self.InsuranceModal.dropDownList.coinTypes.filter(
                    (e) => e.mvalue == data.currency
                  );
                if (currency.length) {
                  data.mapCurrency = true;
                  data.currency = currency[0].mcode;
                } else {
                  data.mapCurrency = true;
                  data.currency = "";
                }
              }
              let matchIdn = self.InsuranceModal.dropDownList.owners.filter(
                (o) => o.name == data.owner
              );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";
              self.InsuranceModal.form = data;
            }
          });

          break;
        case 12:
          //債權
          self.ClaimModal.dropDownList = {
            owners: self.getOwners(),
          };
          self.DetailModalItemBtnClear();
          if (self.ClaimModal.modifiedType === "U") {
            let data = self.ClaimModal.PreData.data;
            let matchIdn = self.ClaimModal.dropDownList.owners.filter(
              (o) => o.name == data.owner
            );
            data.ownerIdn = matchIdn.length ? matchIdn[0].idnOrPassportno : "";
            self.ClaimModal.form = data;
          }
          break;
        case 13:
          //債務
          GetDebtDropDownMenu({}).then((returnData) => {
            self.DebtModal.dropDownList = {
              debtTypes: returnData.returnObject.category,
              owners: self.getOwners(),
            };

            self.DetailModalItemBtnClear();
            if (self.DebtModal.modifiedType === "U") {
              let data = self.DebtModal.PreData.data;
              if (typeof data.debtTypeText == "undefined") {
                let debtTypes = self.DebtModal.dropDownList.debtTypes.filter(
                  (e) => e.mvalue == data.debtType
                );
                if (debtTypes.length) {
                  data.debtType = debtTypes[0].mcode;
                  data.debtTypeText = "";
                } else {
                  data.debtTypeText = data.debtType;
                  data.debtType = "999";
                }
              }
              let matchIdn = self.DebtModal.dropDownList.owners.filter(
                (o) => o.name == data.owner
              );
              data.ownerIdn = matchIdn.length
                ? matchIdn[0].idnOrPassportno
                : "";
              self.DebtModal.form = data;
            }
          });

          break;
        case 14:
          //事業投資
          self.InvestmentModal.dropDownList = {
            owners: self.getOwners(),
          };
          self.DetailModalItemBtnClear();
          if (self.InvestmentModal.modifiedType === "U") {
            let data = self.InvestmentModal.PreData.data;
            let matchIdn = self.InvestmentModal.dropDownList.owners.filter(
              (o) => o.name == data.owner
            );
            data.ownerIdn = matchIdn.length ? matchIdn[0].idnOrPassportno : "";
            self.InvestmentModal.form = data;
          }

          break;
        // case 15:
        //   //備註
        //   self.RemarkModal.show = true;
        //   break;
        case 16:
          //虛擬資產
          self.VirtualAssetsModal.dropDownList = {
            owners: self.getOwners(),
          };
          self.DetailModalItemBtnClear();
          if (self.VirtualAssetsModal.modifiedType === "U") {
            let data = self.VirtualAssetsModal.PreData.data;
            let matchIdn = self.VirtualAssetsModal.dropDownList.owners.filter(
              (o) => o.name == data.ownersName
            );
            data.owners = matchIdn.length ? matchIdn[0].idnOrPassportno : "";
            self.VirtualAssetsModal.form = data;
          }
          break;
      }
    },
    //第三頁各財產存檔
    DetailModalItemBtnSave: function () {
      const self = this;
      self.Alert.txt = [];
      var errMsg = [];
      let postData = {};
      var text = "";

      switch (self.DetailModal.MenuIndex) {
        case 0:
          text =
            self.LandModal.modifiedType == "I" ||
              self.LandModal.modifiedType == "NI"
              ? "新增"
              : self.LandModal.modifiedType == "U"
                ? "修改"
                : self.LandModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          if (self.LandModal.modifiedType != "D") {
            if (self.LandModal.form.address.trim() == "") {
              errMsg.push("請填入土地坐落");
            }
            if (self.LandModal.form.areaSystem.trim() == "") {
              errMsg.push("請填入面積");
            } else {
              if (isNaN(Number(self.LandModal.form.areaSystem))) {
                errMsg.push("面積僅能為數字");
              }
            }
            if (
              self.LandModal.form.rights1.trim() == "" ||
              self.LandModal.form.rights2.trim() == ""
            ) {
              errMsg.push("請填入權利範圍");
            } else {
              if (
                isNaN(Number(self.LandModal.form.rights1)) ||
                isNaN(Number(self.LandModal.form.rights2))
              ) {
                errMsg.push("權利範圍僅能為數字");
              }
            }
            if (self.LandModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入所有權人");
            }
            if (self.LandModal.form.enterDate == "") {
              errMsg.push("請填入登記(取得)時間");
            }
            if (
              self.LandModal.form.price.trim() != "" &&
              isNaN(Number(self.LandModal.form.price))
            ) {
              errMsg.push("取得價額僅能為數字");
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }
          //土地
          postData = {
            modifiedType: self.LandModal.modifiedType,
            verifySeq: self.LandModal.PreData.verifySeq,
            detailSeq: self.LandModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            landData:
              self.LandModal.modifiedType == "D"
                ? {}
                : {
                  address: self.LandModal.form.address,
                  areaSystem: self.LandModal.form.areaSystem,
                  rights1: self.LandModal.form.rights1,
                  rights2: self.LandModal.form.rights2,
                  ownerIdn: self.LandModal.form.ownerIdn,
                  owner: self.LandModal.dropDownList.owners.filter(
                    (o) => o.idnOrPassportno == self.LandModal.form.ownerIdn
                  )[0].name,
                  enterDate: self.LandModal.form.enterDate,
                  enterReason:
                    self.LandModal.form.enterReason == "999"
                      ? self.LandModal.form.enterReasonText
                      : self.LandModal.dropDownList.enterReasons.filter(
                        (l) => l.mcode == self.LandModal.form.enterReason
                      )[0].mvalue,
                  price: self.LandModal.form.price,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "土地存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyLandData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("Land");
                self.Alert.show = false;
                self.LandModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 1:
          //建物
          text =
            self.BuildingModal.modifiedType == "I" ||
              self.BuildingModal.modifiedType == "NI"
              ? "新增"
              : self.BuildingModal.modifiedType == "U"
                ? "修改"
                : self.BuildingModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          if (self.BuildingModal.modifiedType != "D") {
            if (self.BuildingModal.form.address.trim() == "") {
              errMsg.push("請填入地號或門牌號碼");
            }
            if (self.BuildingModal.form.regNo.trim() == "") {
              errMsg.push("請填入建號");
            }
            if (self.BuildingModal.form.areaSystem.trim() == "") {
              //errMsg.push("請填入面積");
            } else {
              if (isNaN(Number(self.BuildingModal.form.areaSystem))) {
                errMsg.push("面積僅能為數字");
              }
            }
            if (self.BuildingModal.form.attachBuildingAreaSystem.trim() == "") {
            } else {
              if (
                isNaN(Number(self.BuildingModal.form.attachBuildingAreaSystem))
              ) {
                errMsg.push("附屬建物總面積僅能為數字");
              }
            }
            if (self.BuildingModal.form.publicAreaSystem.trim() == "") {
            } else {
              if (isNaN(Number(self.BuildingModal.form.publicAreaSystem))) {
                errMsg.push("共同使用部分總面積僅能為數字");
              }
            }
            if (
              self.BuildingModal.form.rights1.trim() == "" ||
              self.BuildingModal.form.rights2.trim() == ""
            ) {
              errMsg.push("請填入權利範圍");
            } else {
              if (
                isNaN(Number(self.BuildingModal.form.rights1)) ||
                isNaN(Number(self.BuildingModal.form.rights2))
              ) {
                errMsg.push("權利範圍僅能為數字");
              }
            }
            if (self.BuildingModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入所有權人");
            }
            if (self.BuildingModal.form.enterDate == "") {
              errMsg.push("請填入登記(取得)時間");
            }
            if (
              self.BuildingModal.form.price.trim() != "" &&
              isNaN(Number(self.BuildingModal.form.price))
            ) {
              errMsg.push("取得價額僅能為數字");
            }

            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }

          postData = {
            modifiedType: self.BuildingModal.modifiedType,
            verifySeq: self.BuildingModal.PreData.verifySeq,
            detailSeq: self.BuildingModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            buildingData:
              self.BuildingModal.modifiedType == "D"
                ? {}
                : {
                  address: self.BuildingModal.form.address,
                  regNo: self.BuildingModal.form.regNo,
                  areaSystem: self.BuildingModal.form.areaSystem,
                  rights1: self.BuildingModal.form.rights1,
                  rights2: self.BuildingModal.form.rights2,
                  ownerIdn: self.BuildingModal.form.ownerIdn,
                  owner: self.BuildingModal.dropDownList.owners.filter(
                    (o) =>
                      o.idnOrPassportno == self.BuildingModal.form.ownerIdn
                  )[0].name,
                  attachBuildingAreaSystem:
                    self.BuildingModal.form.attachBuildingAreaSystem,
                  publicAreaSystem: self.BuildingModal.form.publicAreaSystem,
                  enterDate: self.BuildingModal.form.enterDate,
                  enterReason:
                    self.BuildingModal.form.enterReason == "999"
                      ? self.BuildingModal.form.enterReasonText
                      : self.BuildingModal.dropDownList.enterReasons.filter(
                        (l) =>
                          l.mcode == self.BuildingModal.form.enterReason
                      )[0].mvalue,
                  price: self.BuildingModal.form.price,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "建物存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyBuildingData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("Building");
                self.Alert.show = false;
                self.BuildingModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 2:
          //船舶
          text =
            self.VesselModal.modifiedType == "I" ||
              self.VesselModal.modifiedType == "NI"
              ? "新增"
              : self.VesselModal.modifiedType == "U"
                ? "修改"
                : self.VesselModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          if (self.VesselModal.modifiedType != "D") {
            if (self.VesselModal.form.vesselType.trim() == "") {
              errMsg.push("請填入種類");
            }
            if (self.VesselModal.form.ton.trim() == "") {
              errMsg.push("請填入總噸數(長度、管數)");
            } else {
              if (isNaN(Number(self.VesselModal.form.ton))) {
                errMsg.push("總噸數僅能為數字");
              }
            }
            if (self.VesselModal.form.portReg.trim() == "") {
              errMsg.push("請填入船籍港");
            }
            if (self.VesselModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入所有人");
            }
            if (self.VesselModal.form.enterDate == "") {
              errMsg.push("請填入登記(取得)時間");
            }
            if (
              self.VesselModal.form.price.trim() != "" &&
              isNaN(Number(self.VesselModal.form.price))
            ) {
              errMsg.push("取得價額僅能為數字");
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }

          postData = {
            modifiedType: self.VesselModal.modifiedType,
            verifySeq: self.VesselModal.PreData.verifySeq,
            detailSeq: self.VesselModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            vesselData:
              self.VesselModal.modifiedType == "D"
                ? {}
                : {
                  vesselType:
                    self.VesselModal.form.vesselType == "999"
                      ? self.VesselModal.form.vesselTypeText
                      : self.VesselModal.dropDownList.vesselTypes.filter(
                        (v) => v.mcode === self.VesselModal.form.vesselType
                      )[0].mvalue,
                  ton: self.VesselModal.form.ton,
                  portReg: self.VesselModal.form.portReg,
                  ownerIdn: self.VesselModal.form.ownerIdn,
                  owner: self.VesselModal.dropDownList.owners.filter(
                    (o) => o.idnOrPassportno == self.VesselModal.form.ownerIdn
                  )[0].name,
                  enterDate: self.VesselModal.form.enterDate,
                  enterReason:
                    self.VesselModal.form.enterReason == "999"
                      ? self.VesselModal.form.enterReasonText
                      : self.VesselModal.dropDownList.enterReasons.filter(
                        (e) => e.mcode == self.VesselModal.form.enterReason
                      )[0].mvalue,
                  price: self.VesselModal.form.price,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "船舶存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyVesselData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("Vessel");
                self.Alert.show = false;
                self.VesselModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 3:
          text =
            self.VehicleModal.modifiedType == "I" ||
              self.VehicleModal.modifiedType == "NI"
              ? "新增"
              : self.VehicleModal.modifiedType == "U"
                ? "修改"
                : self.VehicleModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          //汽車
          if (self.VehicleModal.modifiedType != "D") {
            if (self.VehicleModal.form.vehicleType.trim() == "") {
              errMsg.push("請填入種類");
            }
            if (self.VehicleModal.form.brand.trim() == "") {
              errMsg.push("請填入廠牌型號");
            }
            if (self.VehicleModal.form.volume.trim() == "") {
              errMsg.push("請填入汽缸容量");
            } else {
              if (isNaN(Number(self.VehicleModal.form.volume))) {
                errMsg.push("汽缸容量僅能為數字");
              }
            }
            if (self.VehicleModal.form.islicenseNo.trim() == "") {
              errMsg.push("請選擇牌照號碼或引擎號碼");
            }
            if (self.VehicleModal.form.licenseNo.trim() == "") {
              errMsg.push("請填入照號碼或引擎號碼");
            }
            if (self.VehicleModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入所有人");
            }
            if (self.VehicleModal.form.enterDate == "") {
              errMsg.push("請填入登記(取得)時間");
            }
            if (
              self.VehicleModal.form.price.trim() != "" &&
              isNaN(Number(self.VehicleModal.form.price))
            ) {
              errMsg.push("取得價額僅能為數字");
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }

          postData = {
            modifiedType: self.VehicleModal.modifiedType,
            verifySeq: self.VehicleModal.PreData.verifySeq,
            detailSeq: self.VehicleModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            vehicleData:
              self.VehicleModal.modifiedType == "D"
                ? {}
                : {
                  vehicleType:
                    self.VehicleModal.form.vehicleType === "999"
                      ? self.VehicleModal.form.vehicleTypeText
                      : self.VehicleModal.dropDownList.vehicleTypes.filter(
                        (v) => v.mcode == self.VehicleModal.form.vehicleType
                      )[0].mvalue,
                  volume: self.VehicleModal.form.volume,
                  islicenseNo: self.VehicleModal.form.islicenseNo,
                  licenseNo: self.VehicleModal.form.licenseNo,
                  ownerIdn: self.VehicleModal.form.ownerIdn,
                  owner: self.VehicleModal.dropDownList.owners.filter(
                    (o) =>
                      o.idnOrPassportno == self.VehicleModal.form.ownerIdn
                  )[0].name,
                  brand: self.VehicleModal.form.brand,
                  enterDate: self.VehicleModal.form.enterDate,
                  enterReason:
                    self.VehicleModal.form.enterReason === "999"
                      ? self.VehicleModal.form.enterReasonText
                      : self.VehicleModal.dropDownList.enterReasons.filter(
                        (e) => e.mcode == self.VehicleModal.form.enterReason
                      )[0].mvalue,
                  price: self.VehicleModal.form.price,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "汽車存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyVehicleData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("Vehicle");
                self.Alert.show = false;
                self.VehicleModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 4:
          text =
            self.AircraftModal.modifiedType == "I"
              ? "新增"
              : self.AircraftModal.modifiedType == "U"
                ? "修改"
                : self.AircraftModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          //航空器
          if (self.AircraftModal.modifiedType != "D") {
            if (self.AircraftModal.form.aircraftType.trim() == "") {
              errMsg.push("請填入型式");
            }
            if (self.AircraftModal.form.factoryName.trim() == "") {
              errMsg.push("請填入製造廠名稱");
            }
            if (self.AircraftModal.form.nationNumber.trim() == "") {
              errMsg.push("請填入國籍標示及編號");
            }
            if (self.AircraftModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入所有人");
            }
            if (self.AircraftModal.form.enterDate == "") {
              errMsg.push("請填入登記(取得)時間");
            }
            if (
              self.AircraftModal.form.price.trim() != "" &&
              isNaN(Number(self.AircraftModal.form.price))
            ) {
              errMsg.push("取得價額僅能為數字");
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }

          postData = {
            modifiedType: self.AircraftModal.modifiedType,
            verifySeq: self.AircraftModal.PreData.verifySeq,
            detailSeq: self.AircraftModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            aircraftData:
              self.AircraftModal.modifiedType == "D"
                ? {}
                : {
                  aircraftType: self.AircraftModal.form.aircraftType,
                  factoryName: self.AircraftModal.form.factoryName,
                  nationNumber: self.AircraftModal.form.nationNumber,
                  ownerIdn: self.AircraftModal.form.ownerIdn,
                  owner: self.AircraftModal.dropDownList.owners.filter(
                    (o) =>
                      o.idnOrPassportno == self.AircraftModal.form.ownerIdn
                  )[0].name,
                  enterDate: self.AircraftModal.form.enterDate,
                  enterReason:
                    self.AircraftModal.form.enterReason == "999"
                      ? self.AircraftModal.form.enterReasonText
                      : self.AircraftModal.dropDownList.enterReasons.filter(
                        (e) =>
                          e.mcode == self.AircraftModal.form.enterReason
                      )[0].mvalue,
                  price: self.AircraftModal.form.price,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "航空器存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyAircraftData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["存檔完成"];
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("Aircraft");
                self.Alert.show = false;
                self.AircraftModal.show = false;
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              self.Alert.txt = ["存檔失敗"];
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 5:
          //現金
          text =
            self.CurrencyModal.modifiedType == "I" ||
              self.CurrencyModal.modifiedType == "NI"
              ? "新增"
              : self.CurrencyModal.modifiedType == "U"
                ? "修改"
                : self.CurrencyModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          if (self.CurrencyModal.modifiedType != "D") {
            if (self.CurrencyModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入所有人");
            }
            if (
              self.CurrencyModal.form.foreignSum.trim() != "" &&
              isNaN(Number(self.CurrencyModal.form.foreignSum))
            ) {
              errMsg.push("外幣總額僅能為數字");
            }
            if (
              self.CurrencyModal.form.excRate.trim() != "" &&
              isNaN(Number(self.CurrencyModal.form.excRate))
            ) {
              errMsg.push("匯率僅能為數字");
            }

            if (self.CurrencyModal.form.twdSum.trim() == "") {
              errMsg.push("請填入新臺幣總額或折合新臺幣總額");
            } else {
              if (isNaN(Number(self.CurrencyModal.form.twdSum))) {
                errMsg.push("新臺幣總額或折合新臺幣總額僅能為數字");
              }
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }
          postData = {
            modifiedType: self.CurrencyModal.modifiedType,
            verifySeq: self.CurrencyModal.PreData.verifySeq,
            detailSeq: self.CurrencyModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            currencyData:
              self.CurrencyModal.modifiedType == "D"
                ? {}
                : {
                  ownerIdn: self.CurrencyModal.form.ownerIdn,
                  owner: self.CurrencyModal.dropDownList.owners.filter(
                    (o) =>
                      o.idnOrPassportno == self.CurrencyModal.form.ownerIdn
                  )[0].name,
                  currency: self.CurrencyModal.dropDownList.coinTypes.filter(
                    (c) => c.mcode == self.CurrencyModal.form.currency
                  ).length
                    ? self.CurrencyModal.dropDownList.coinTypes.filter(
                      (c) => c.mcode == self.CurrencyModal.form.currency
                    )[0].mvalue
                    : "",
                  excRate: self.CurrencyModal.form.excRate,
                  foreignSum: self.CurrencyModal.form.foreignSum,
                  twdSum: self.CurrencyModal.form.twdSum,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "現金存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyCurrencyData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("FCurrency");
                self.Alert.show = false;
                self.CurrencyModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 6:
          //存款
          text =
            self.DepositModal.modifiedType == "I" ||
              self.DepositModal.modifiedType == "NI"
              ? "新增"
              : self.DepositModal.modifiedType == "U"
                ? "修改"
                : self.DepositModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          if (self.DepositModal.modifiedType != "D") {
            if (self.DepositModal.form.category.trim() == "") {
              errMsg.push("請填入類別");
            }
            if (self.DepositModal.form.depositType.trim() == "") {
              errMsg.push("請填入種類");
            }
            if (self.DepositModal.form.institution.trim() == "") {
              errMsg.push("請填入存放機構");
            }
            if (self.DepositModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入所有人");
            }
            if (
              self.DepositModal.form.foreignSum.trim() != "" &&
              isNaN(Number(self.DepositModal.form.foreignSum))
            ) {
              errMsg.push("外幣總額僅能為數字");
            }
            if (
              self.DepositModal.form.excRate.trim() != "" &&
              isNaN(Number(self.DepositModal.form.excRate))
            ) {
              errMsg.push("匯率僅能為數字");
            }

            if (self.DepositModal.form.twdSum.trim() == "") {
              errMsg.push("請填入新臺幣總額或折合新臺幣總額");
            } else {
              if (isNaN(Number(self.DepositModal.form.twdSum))) {
                errMsg.push("新臺幣總額或折合新臺幣總額僅能為數字");
              }
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }
          postData = {
            modifiedType: self.DepositModal.modifiedType,
            verifySeq: self.DepositModal.PreData.verifySeq,
            detailSeq: self.DepositModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            depositData:
              self.DepositModal.modifiedType == "D"
                ? {}
                : {
                  ownerIdn: self.DepositModal.form.ownerIdn,
                  category: self.DepositModal.form.category,
                  depositType:
                    self.DepositModal.form.depositType === "999"
                      ? self.DepositModal.form.depositTypeText
                      : self.DepositModal.dropDownList.categorys.filter(
                        (c) => c.mcode == self.DepositModal.form.depositType
                      )[0].mvalue,
                  institution: self.DepositModal.form.institution,
                  owner: self.DepositModal.dropDownList.owners.filter(
                    (o) =>
                      o.idnOrPassportno == self.DepositModal.form.ownerIdn
                  )[0].name,
                  currency: self.DepositModal.dropDownList.coinTypes.filter(
                    (c) => c.mcode == self.DepositModal.form.currency
                  ).length
                    ? self.DepositModal.dropDownList.coinTypes.filter(
                      (c) => c.mcode == self.DepositModal.form.currency
                    )[0].mvalue
                    : "",
                  excRate: self.DepositModal.form.excRate,
                  foreignSum: self.DepositModal.form.foreignSum,
                  twdSum: self.DepositModal.form.twdSum,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "存款存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyDepositData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("Deposit");
                self.Alert.show = false;
                self.DepositModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 7:
          //有價證券(股票)
          text =
            self.StockModal.modifiedType == "I" ||
              self.StockModal.modifiedType == "NI"
              ? "新增"
              : self.StockModal.modifiedType == "U"
                ? "修改"
                : self.StockModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          if (self.StockModal.modifiedType != "D") {
            if (self.StockModal.form.stockCode.trim() == "") {
              errMsg.push("請填入股票代碼");
            }
            if (self.StockModal.form.stockName.trim() == "") {
              errMsg.push("請填入股票名稱");
            }
            if (self.StockModal.form.share.trim() == "") {
              errMsg.push("請填入股數");
            } else {
              if (isNaN(Number(self.StockModal.form.share))) {
                errMsg.push("股數僅能為數字");
              }
            }
            if (self.StockModal.form.parValue.trim() == "") {
              errMsg.push("請填入票面價額");
            } else {
              if (isNaN(Number(self.StockModal.form.parValue))) {
                errMsg.push("票面價額僅能為數字");
              }
            }
            if (self.StockModal.form.currency.trim() == "") {
              errMsg.push("請填入幣別");
            }
            if (self.StockModal.form.excRate.trim() == "") {
              errMsg.push("請填入匯率");
            } else {
              if (isNaN(Number(self.StockModal.form.excRate))) {
                errMsg.push("匯率僅能為數字");
              }
            }
            if (self.StockModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入所有人");
            }
            if (self.StockModal.form.twdSum.trim() == "") {
              errMsg.push("請填入新臺幣總額或折合新臺幣總額");
            } else {
              if (isNaN(Number(self.StockModal.form.twdSum))) {
                errMsg.push("新臺幣總額或折合新臺幣總額僅能為數字");
              }
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }

          postData = {
            modifiedType: self.StockModal.modifiedType,
            verifySeq: self.StockModal.PreData.verifySeq,
            detailSeq: self.StockModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            stockData:
              self.StockModal.modifiedType == "D"
                ? {}
                : {
                  ownerIdn: self.StockModal.form.ownerIdn,
                  owner: self.StockModal.dropDownList.owners.filter(
                    (o) => o.idnOrPassportno == self.StockModal.form.ownerIdn
                  )[0].name,
                  stockCode: self.StockModal.form.stockCode,
                  stockName: self.StockModal.form.stockName,
                  share: self.StockModal.form.share,
                  parValue: self.StockModal.form.parValue,
                  currency: self.StockModal.dropDownList.coinTypes.filter(
                    (c) => c.mcode == self.StockModal.form.currency
                  ).length
                    ? self.StockModal.dropDownList.coinTypes.filter(
                      (c) => c.mcode == self.StockModal.form.currency
                    )[0].mvalue
                    : "",
                  excRate: self.StockModal.form.excRate,
                  twdSum: self.StockModal.form.twdSum,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "有價證券(股票)存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyStockData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("StocknBond_1");
                self.Alert.show = false;
                self.StockModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 8:
          //有價證券(票券，債券，其他有價證券)
          text =
            self.BondValuePaperModal.modifiedType == "I" ||
              self.BondValuePaperModal.modifiedType == "NI"
              ? "新增"
              : self.BondValuePaperModal.modifiedType == "U"
                ? "修改"
                : self.BondValuePaperModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          if (self.BondValuePaperModal.modifiedType != "D") {
            if (self.BondValuePaperModal.form.stockCode.trim() == "") {
              errMsg.push("請填入代碼");
            }
            if (self.BondValuePaperModal.form.stockName.trim() == "") {
              errMsg.push("請填入名稱");
            }
            if (self.BondValuePaperModal.form.share.trim() == "") {
              errMsg.push("請填入單位數");
            } else {
              if (isNaN(Number(self.BondValuePaperModal.form.share))) {
                errMsg.push("單位數僅能為數字");
              }
            }
            if (self.BondValuePaperModal.form.parValue.trim() == "") {
              errMsg.push("請填入票面價額");
            } else {
              if (isNaN(Number(self.BondValuePaperModal.form.parValue))) {
                errMsg.push("票面價額僅能為數字");
              }
            }
            if (self.BondValuePaperModal.form.currency.trim() == "") {
              errMsg.push("請填入幣別");
            }
            if (self.BondValuePaperModal.form.excRate.trim() == "") {
              errMsg.push("請填入匯率");
            } else {
              if (isNaN(Number(self.BondValuePaperModal.form.excRate))) {
                errMsg.push("匯率僅能為數字");
              }
            }
            if (self.BondValuePaperModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入所有人");
            }
            if (self.BondValuePaperModal.form.twdSum.trim() == "") {
              errMsg.push("請填入新臺幣總額或折合新臺幣總額");
            } else {
              if (isNaN(Number(self.BondValuePaperModal.form.twdSum))) {
                errMsg.push("新臺幣總額或折合新臺幣總額僅能為數字");
              }
            }
            if (self.BondValuePaperModal.form.institution.trim() == "") {
              errMsg.push("請填入買賣機構或受託投資機構");
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }

          postData = {
            modifiedType: self.BondValuePaperModal.modifiedType,
            verifySeq: self.BondValuePaperModal.PreData.verifySeq,
            detailSeq: self.BondValuePaperModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            bondValuePaperData:
              self.BondValuePaperModal.modifiedType == "D"
                ? {}
                : {
                  ownerIdn: self.BondValuePaperModal.form.ownerIdn,
                  owner: self.BondValuePaperModal.dropDownList.owners.filter(
                    (o) =>
                      o.idnOrPassportno == self.BondValuePaperModal.form.ownerIdn
                  )[0].name,
                  stockCode: self.BondValuePaperModal.form.stockCode,
                  stockName: self.BondValuePaperModal.form.stockName,
                  share: self.BondValuePaperModal.form.share,
                  parValue: self.BondValuePaperModal.form.parValue,
                  currency:
                    self.BondValuePaperModal.dropDownList.coinTypes.filter(
                      (c) => c.mcode == self.BondValuePaperModal.form.currency
                    )
                      ? self.BondValuePaperModal.dropDownList.coinTypes.filter(
                        (c) =>
                          c.mcode == self.BondValuePaperModal.form.currency
                      )[0].mvalue
                      : "",
                  excRate: self.BondValuePaperModal.form.excRate,
                  institution: self.BondValuePaperModal.form.institution,
                  twdSum: self.BondValuePaperModal.form.twdSum,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "有價證券(票券，債券，其他有價證券)存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyBondValuePaperData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("StocknBond_2");
                self.Alert.show = false;
                self.BondValuePaperModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 9:
          text =
            self.FundModal.modifiedType == "I" ||
              self.FundModal.modifiedType == "NI"
              ? "新增"
              : self.FundModal.modifiedType == "U"
                ? "修改"
                : self.FundModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          //有價證券(基金受益憑證)
          if (self.FundModal.modifiedType != "D") {
            if (self.FundModal.form.stockName.trim() == "") {
              errMsg.push("請填入名稱");
            }
            if (self.FundModal.form.share.trim() == "") {
              errMsg.push("請填入單位數");
            } else {
              if (isNaN(Number(self.FundModal.form.share))) {
                errMsg.push("單位數僅能為數字");
              }
            }
            if (self.FundModal.form.parValue.trim() == "") {
              errMsg.push("請填入票面價額/單位淨值");
            } else {
              if (isNaN(Number(self.FundModal.form.parValue))) {
                errMsg.push("票面價額/單位淨值能為數字");
              }
            }
            if (self.FundModal.form.currency.trim() == "") {
              errMsg.push("請填入幣別");
            }
            if (self.FundModal.form.excRate.trim() == "") {
              errMsg.push("請填入匯率");
            } else {
              if (isNaN(Number(self.FundModal.form.excRate))) {
                errMsg.push("匯率僅能為數字");
              }
            }
            if (self.FundModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入所有人");
            }
            if (self.FundModal.form.twdSum.trim() == "") {
              errMsg.push("請填入新臺幣總額或折合新臺幣總額");
            } else {
              if (isNaN(Number(self.FundModal.form.twdSum))) {
                errMsg.push("新臺幣總額或折合新臺幣總額僅能為數字");
              }
            }
            if (self.FundModal.form.institution == "") {
              errMsg.push("請填入受託投資機構");
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }

          postData = {
            modifiedType: self.FundModal.modifiedType,
            verifySeq: self.FundModal.PreData.verifySeq,
            detailSeq: self.FundModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            fundData:
              self.FundModal.modifiedType == "D"
                ? {}
                : {
                  ownerIdn: self.FundModal.form.ownerIdn,
                  owner: self.FundModal.dropDownList.owners.filter(
                    (o) => o.idnOrPassportno == self.FundModal.form.ownerIdn
                  )[0].name,
                  stockCode: self.FundModal.form.stockCode,
                  stockName: self.FundModal.form.stockName,
                  share: self.FundModal.form.share,
                  parValue: self.FundModal.form.parValue,
                  currency: self.FundModal.dropDownList.coinTypes.filter(
                    (c) => c.mcode == self.FundModal.form.currency
                  )
                    ? self.FundModal.dropDownList.coinTypes.filter(
                      (c) => c.mcode == self.FundModal.form.currency
                    )[0].mvalue
                    : "",
                  excRate: self.FundModal.form.excRate,
                  institution: self.FundModal.form.institution,
                  twdSum: self.FundModal.form.twdSum,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "有價證券(基金)存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyFundData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("StocknBond_3");
                self.Alert.show = false;
                self.FundModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 10:
          text =
            self.OtherPropertyModal.modifiedType == "I" ||
              self.OtherPropertyModal.modifiedType == "NI"
              ? "新增"
              : self.OtherPropertyModal.modifiedType == "U"
                ? "修改"
                : self.OtherPropertyModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          //其他財產
          if (self.OtherPropertyModal.modifiedType != "D") {
            if (self.OtherPropertyModal.form.otherPropertiesType.trim() == "") {
              errMsg.push("請填入財產種類");
            }
            if (self.OtherPropertyModal.form.otherQuantity.trim() == "") {
              errMsg.push("請填入項/件");
            } else {
              if (isNaN(Number(self.OtherPropertyModal.form.otherQuantity))) {
                errMsg.push("項/件能為數字");
              }
            }
            if (self.OtherPropertyModal.form.price.trim() == "") {
              errMsg.push("請填入價額");
            } else {
              if (isNaN(Number(self.OtherPropertyModal.form.price))) {
                errMsg.push("價額僅能為數字");
              }
            }
            if (self.OtherPropertyModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入所有人");
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }

          postData = {
            modifiedType: self.OtherPropertyModal.modifiedType,
            verifySeq: self.OtherPropertyModal.PreData.verifySeq,
            detailSeq: self.OtherPropertyModal.PreData.detailSeq, //'U' key
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            otherPropertyData:
              self.OtherPropertyModal.modifiedType == "D"
                ? {}
                : {
                  ownerIdn: self.OtherPropertyModal.form.ownerIdn,
                  owner: self.OtherPropertyModal.dropDownList.owners.filter(
                    (o) =>
                      o.idnOrPassportno == self.OtherPropertyModal.form.ownerIdn
                  )[0].name,
                  otherPropertiesType:
                    self.OtherPropertyModal.form.otherPropertiesType,
                  otherQuantity: self.OtherPropertyModal.form.otherQuantity,
                  price: self.OtherPropertyModal.form.price,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "其他財產存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyOtherPropertyData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("Misc");
                self.Alert.show = false;
                self.OtherPropertyModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 11:
          text =
            self.InsuranceModal.modifiedType == "I" ||
              self.InsuranceModal.modifiedType == "NI"
              ? "新增"
              : self.InsuranceModal.modifiedType == "U"
                ? "修改"
                : self.InsuranceModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          //保險
          if (self.InsuranceModal.modifiedType != "D") {
            if (self.InsuranceModal.form.companyName.trim() == "") {
              errMsg.push("請填入保險公司");
            }
            if (self.InsuranceModal.form.insuranceName.trim() == "") {
              errMsg.push("請填入保險名稱");
            }
            if (self.InsuranceModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入要保人");
            }

            if (self.InsuranceModal.isNew || self.InsuranceModal.isNew2) {
              if (self.InsuranceModal.form.insuranceNo == null || self.InsuranceModal.form.insuranceNo.trim() == "") {
                errMsg.push("請填入保單號碼");
              }
              if (self.InsuranceModal.form.contractType == null || self.InsuranceModal.form.contractType.trim() == "") {
                errMsg.push("請填入保險契約類型");
              }
              if (self.InsuranceModal.form.startDate == null || self.InsuranceModal.form.startDate.trim() == "") {
                errMsg.push("請填入契約始日");
              } else {
                if (self.InsuranceModal.form.startDate.length != 7) {
                  errMsg.push("契約始日須為民國年七碼");
                }
              }
              if (self.InsuranceModal.form.endDate == null || self.InsuranceModal.form.endDate.trim() == "") {
                errMsg.push("請填入契約終日");
              } else {
                if (
                  !(
                    self.InsuranceModal.form.endDate.length == 7 ||
                    self.InsuranceModal.form.endDate == "終身"
                  )
                ) {
                  errMsg.push("契約終日須為民國年七碼");
                }
              }
              //1120901以後沒有「保險金額、幣別、累積已繳保險金額、匯率、累積已繳保險金額折合新臺幣」
              if (self.InsuranceModal.isNew) {
                if (self.InsuranceModal.form.amount == null || self.InsuranceModal.form.amount.trim() == "") {
                  errMsg.push("請填入保險金額");
                } else {
                  if (isNaN(Number(self.InsuranceModal.form.amount))) {
                    errMsg.push("保險金額僅能為數字");
                  }
                }
                if (self.InsuranceModal.form.currency == null || self.InsuranceModal.form.currency.trim() == "") {
                  errMsg.push("請填入外幣幣別");
                } else {
                  if (!(self.InsuranceModal.form.currency === "1" || self.InsuranceModal.form.currency === "42")) {
                    if (self.InsuranceModal.form.rate == null || self.InsuranceModal.form.rate.trim() == "") {
                      errMsg.push("請填入匯率");
                    } else {
                      if (isNaN(Number(self.InsuranceModal.form.rate))) {
                        errMsg.push("匯率僅能為數字");
                      }
                    }

                    if (
                      self.InsuranceModal.form.contractAggregatePremium == null || self.InsuranceModal.form.contractAggregatePremium.trim() ==
                      ""
                    ) {
                      errMsg.push("請填入累積已繳保險費外幣總額");
                    } else {
                      if (
                        isNaN(
                          Number(
                            self.InsuranceModal.form.contractAggregatePremium
                          )
                        )
                      ) {
                        errMsg.push("累積已繳保險費外幣總額僅能為數字");
                      }
                    }
                  }
                }
                if (
                  self.InsuranceModal.form.contractAggregatePremiumNt == null || self.InsuranceModal.form.contractAggregatePremiumNt.trim() == ""
                ) {
                  errMsg.push("請填入累積已繳保險費折合新臺幣總額");
                } else {
                  if (
                    isNaN(
                      Number(self.InsuranceModal.form.contractAggregatePremiumNt)
                    )
                  ) {
                    errMsg.push("累積已繳保險費折合新臺幣總額僅能為數字");
                  }
                }
              }
            }

            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }
          postData = {
            modifiedType: self.InsuranceModal.modifiedType,
            verifySeq: self.InsuranceModal.PreData.verifySeq,
            detailSeq: self.InsuranceModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            insuranceData:
              self.InsuranceModal.modifiedType == "D"
                ? {}
                : self.InsuranceModal.isNew2 ? {
                  ownerIdn: self.InsuranceModal.form.ownerIdn,
                    owner: self.InsuranceModal.dropDownList.owners.filter(
                      (o) =>
                        o.idnOrPassportno == self.InsuranceModal.form.ownerIdn
                    )[0].name,
                    companyName:
                      self.InsuranceModal.form.companyName === "999"
                        ? self.InsuranceModal.form.companyNameText
                        : self.InsuranceModal.dropDownList.companyNames.filter(
                          (c) =>
                            c.mcode == self.InsuranceModal.form.companyName
                        )[0].mvalue,
                    insuranceName: self.InsuranceModal.form.insuranceName,
                    insuranceNo: self.InsuranceModal.form.insuranceNo,
                    contractType: self.InsuranceModal.form.contractType,
                    startDate: self.InsuranceModal.form.startDate,
                    endDate: self.InsuranceModal.form.endDate,
                }
                : self.InsuranceModal.isNew
                  ? {
                    ownerIdn: self.InsuranceModal.form.ownerIdn,
                    owner: self.InsuranceModal.dropDownList.owners.filter(
                      (o) =>
                        o.idnOrPassportno == self.InsuranceModal.form.ownerIdn
                    )[0].name,
                    companyName:
                      self.InsuranceModal.form.companyName === "999"
                        ? self.InsuranceModal.form.companyNameText
                        : self.InsuranceModal.dropDownList.companyNames.filter(
                          (c) =>
                            c.mcode == self.InsuranceModal.form.companyName
                        )[0].mvalue,
                    insuranceName: self.InsuranceModal.form.insuranceName,
                    remark: self.InsuranceModal.form.remark,
                    insuranceNo: self.InsuranceModal.form.insuranceNo,
                    contractType: self.InsuranceModal.form.contractType,
                    startDate: self.InsuranceModal.form.startDate,
                    endDate: self.InsuranceModal.form.endDate,
                    amount: self.InsuranceModal.form.amount,
                    contractAggregatePremium:
                      self.InsuranceModal.form.contractAggregatePremium,
                    contractAggregatePremiumNt:
                      self.InsuranceModal.form.contractAggregatePremiumNt,
                    currency: self.InsuranceModal.dropDownList.coinTypes.filter(
                      (c) => c.mcode == self.InsuranceModal.form.currency
                    )
                      ? self.InsuranceModal.dropDownList.coinTypes.filter(
                        (c) => c.mcode == self.InsuranceModal.form.currency
                      )[0].mvalue
                      : "",
                    rate: self.InsuranceModal.form.rate,
                  }
                  : {
                    ownerIdn: self.InsuranceModal.form.ownerIdn,
                    owner: self.InsuranceModal.dropDownList.owners.filter(
                      (o) =>
                        o.idnOrPassportno == self.InsuranceModal.form.ownerIdn
                    )[0].name,
                    companyName:
                      self.InsuranceModal.form.companyName === "999"
                        ? self.InsuranceModal.form.companyNameText
                        : self.InsuranceModal.dropDownList.companyNames.filter(
                          (c) =>
                            c.mcode == self.InsuranceModal.form.companyName
                        )[0].mvalue,
                    insuranceName: self.InsuranceModal.form.insuranceName,
                    remark: self.InsuranceModal.form.remark,
                  },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "保險存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyInsuranceData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("Insurance");
                self.Alert.show = false;
                self.InsuranceModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 12:
          //債權
          text =
            self.ClaimModal.modifiedType == "I" ||
              self.ClaimModal.modifiedType == "NI"
              ? "新增"
              : self.ClaimModal.modifiedType == "U"
                ? "修改"
                : self.ClaimModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          if (self.ClaimModal.modifiedType != "D") {
            if (self.ClaimModal.form.claimsType.trim() == "") {
              errMsg.push("請填入種類");
            }
            if (self.ClaimModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入債權人");
            }
            if (self.ClaimModal.form.debtorName.trim() == "") {
              errMsg.push("請填入債務人");
            }
            // if (self.ClaimModal.form.debtorAddr.trim() == "") {
            //   errMsg.push("請填入債務人地圵");
            // }
            if (self.ClaimModal.form.twdSum.trim() == "") {
              errMsg.push("請填入餘額");
            } else {
              if (isNaN(Number(self.ClaimModal.form.twdSum))) {
                errMsg.push("餘額僅能為數字");
              }
            }
            if (self.ClaimModal.form.enterDate == "") {
              errMsg.push("請填入取得(發生)時間");
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }

          postData = {
            modifiedType: self.ClaimModal.modifiedType,
            verifySeq: self.ClaimModal.PreData.verifySeq,
            detailSeq: self.ClaimModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            claimData:
              self.ClaimModal.modifiedType == "D"
                ? {}
                : {
                  claimsType: self.ClaimModal.form.claimsType,
                  ownerIdn: self.ClaimModal.form.ownerIdn,
                  owner: self.ClaimModal.dropDownList.owners.filter(
                    (o) => o.idnOrPassportno == self.ClaimModal.form.ownerIdn
                  )[0].name,
                  debtorName: self.ClaimModal.form.debtorName,
                  debtorAddr: self.ClaimModal.form.debtorAddr,
                  twdSum: self.ClaimModal.form.twdSum,
                  enterDate: self.ClaimModal.form.enterDate,
                  enterReason: self.ClaimModal.form.enterReason,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "債權存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyClaimData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("Credit");
                self.Alert.show = false;
                self.ClaimModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 13:
          text =
            self.DebtModal.modifiedType == "I" ||
              self.DebtModal.modifiedType == "NI"
              ? "新增"
              : self.DebtModal.modifiedType == "U"
                ? "修改"
                : self.DebtModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          //債務
          if (self.DebtModal.modifiedType != "D") {
            if (self.DebtModal.form.debtType.trim() == "") {
              errMsg.push("請填入種類");
            }
            if (self.DebtModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入債務人");
            }
            if (self.DebtModal.form.claimsName.trim() == "") {
              errMsg.push("請填入債權人");
            }
            // if (self.DebtModal.form.claimsAddr.trim() == "") {
            //   errMsg.push("請填入債務人地圵");
            // }
            if (self.DebtModal.form.twdSum.trim() == "") {
              errMsg.push("請填入餘額");
            } else {
              if (isNaN(Number(self.DebtModal.form.twdSum))) {
                errMsg.push("餘額僅能為數字");
              }
            }
            if (self.DebtModal.form.enterDate == "") {
              errMsg.push("請填入取得(發生)時間");
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }

          postData = {
            modifiedType: self.DebtModal.modifiedType,
            verifySeq: self.DebtModal.PreData.verifySeq,
            detailSeq: self.DebtModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            debtData:
              self.DebtModal.modifiedType == "D"
                ? {}
                : {
                  ownerIdn: self.DebtModal.form.ownerIdn,
                  debtType:
                    self.DebtModal.form.debtType == "999"
                      ? self.DebtModal.form.debtTypeText
                      : self.DebtModal.dropDownList.debtTypes.filter(
                        (x) => x.mcode == self.DebtModal.form.debtType
                      )[0].mvalue,
                  owner: self.DebtModal.dropDownList.owners.filter(
                    (o) => o.idnOrPassportno == self.DebtModal.form.ownerIdn
                  )[0].name,
                  claimsName: self.DebtModal.form.claimsName,
                  claimsAddr: self.DebtModal.form.claimsAddr,
                  twdSum: self.DebtModal.form.twdSum,
                  enterDate: self.DebtModal.form.enterDate,
                  enterReason: self.DebtModal.form.enterReason,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "債務存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyDebtData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("Debit");
                self.Alert.show = false;
                self.DebtModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        case 14:
          text =
            self.InvestmentModal.modifiedType == "I"
              ? "新增"
              : self.InvestmentModal.modifiedType == "U"
                ? "修改"
                : self.InvestmentModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          //事業投資
          if (self.InvestmentModal.modifiedType != "D") {
            if (self.InvestmentModal.form.ownerIdn.trim() == "") {
              errMsg.push("請填入投資人");
            }
            if (self.InvestmentModal.form.companyName.trim() == "") {
              errMsg.push("請填入投資事業名稱");
            }
            if (self.InvestmentModal.form.companyAddress.trim() == "") {
              errMsg.push("請填入事業投資地圵");
            }
            if (self.InvestmentModal.form.priceTotal.trim() == "") {
              errMsg.push("請填入投資金額");
            } else {
              if (isNaN(Number(self.InvestmentModal.form.priceTotal))) {
                errMsg.push("投資金額僅能為數字");
              }
            }
            if (self.InvestmentModal.form.enterDate == "") {
              errMsg.push("請填入取得(發生)時間");
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }

          postData = {
            modifiedType: self.InvestmentModal.modifiedType,
            verifySeq: self.InvestmentModal.PreData.verifySeq,
            detailSeq: self.InvestmentModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            investmentData:
              self.InvestmentModal.modifiedType == "D"
                ? {}
                : {
                  ownerIdn: self.InvestmentModal.form.ownerIdn,
                  owner: self.InvestmentModal.dropDownList.owners.filter(
                    (o) => o.idnOrPassportno == self.InvestmentModal.form.ownerIdn
                  )[0].name,
                  companyName: self.InvestmentModal.form.companyName,
                  companyAddress: self.InvestmentModal.form.companyAddress,
                  priceTotal: self.InvestmentModal.form.priceTotal,
                  enterDate: self.InvestmentModal.form.enterDate,
                  enterReason: self.InvestmentModal.form.enterReason,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "事業投資存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyInvestmentData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["存檔完成"];
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("Investment");
                self.Alert.show = false;
                self.InvestmentModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              self.Alert.txt = ["存檔失敗"];
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
        // case 15:
        //   //備註
        //   self.RemarkModal.show = true;
        //   break;
        case 16:
          //虛擬資產
          text =
            self.VirtualAssetsModal.modifiedType == "I" ||
              self.VirtualAssetsModal.modifiedType == "NI"
              ? "新增"
              : self.VirtualAssetsModal.modifiedType == "U"
                ? "修改"
                : self.VirtualAssetsModal.modifiedType == "D"
                  ? "刪除"
                  : "存檔";
          if (self.VirtualAssetsModal.modifiedType != "D") {
            if (self.VirtualAssetsModal.form.virtualAssetName.trim() == "") {
              errMsg.push("請填入名稱");
            }
            if (self.VirtualAssetsModal.form.owners.trim() == "") {
              errMsg.push("請填入所有人");
            }
            if (self.VirtualAssetsModal.form.amount.trim() == "") {
              errMsg.push("請填入單位數");
            } else {
              if (isNaN(Number(self.VirtualAssetsModal.form.amount))) {
                errMsg.push("單位數僅能為數字");
              }
            }
            if (self.VirtualAssetsModal.form.institution.trim() == "") {
              errMsg.push("請填入存放機構");
            }
            if (self.VirtualAssetsModal.form.account.trim() == "") {
              errMsg.push("請填入帳戶名稱");
            }
            if (self.VirtualAssetsModal.form.twdSum.trim() == "") {
              errMsg.push("請填入新臺幣總額或折合新臺幣總額");
            } else {
              if (isNaN(Number(self.VirtualAssetsModal.form.twdSum))) {
                errMsg.push("新臺幣總額或折合新臺幣總額僅能為數字");
              }
            }
            if (errMsg.length > 0) {
              self.Alert.txt = errMsg;
              self.Alert.show = true;
              self.Alert.title = "提醒";
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              return false;
            }
          }
          postData = {
            modifiedType: self.VirtualAssetsModal.modifiedType,
            verifySeq: self.VirtualAssetsModal.PreData.verifySeq,
            detailSeq: self.VirtualAssetsModal.PreData.detailSeq,
            seqno: self.DetailModal.PreData.seqno,
            Auth_SEQ: self.DetailModal.PreData.auth_SEQ,
            virtualAssetsData:
              self.VirtualAssetsModal.modifiedType == "D"
                ? {}
                : {
                  VirtualAssetName: self.VirtualAssetsModal.form.virtualAssetName,
                  Owners: self.VirtualAssetsModal.form.owners,
                  OwnersName: self.VirtualAssetsModal.dropDownList.owners.filter(
                    (o) =>
                      o.idnOrPassportno == self.VirtualAssetsModal.form.owners
                  )[0].name,
                  Amount: self.VirtualAssetsModal.form.amount,
                  AmountUnit: self.VirtualAssetsModal.form.amountUnit,
                  Institution: self.VirtualAssetsModal.form.institution,
                  Account: self.VirtualAssetsModal.form.account,
                  EnterReason: self.VirtualAssetsModal.form.enterReason,                
                  TwdSum: self.VirtualAssetsModal.form.twdSum,
                },
            idn: self.DetailModal.PreData.idn,
            syear: self.DetailModal.PreData.syear,
            goV_CODE: self.DetailModal.PreData.goV_CODE,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd: "虛擬資產存檔",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          F201_updateVerifyVirtualAssetsData(postData).then((rData) => {
            //console.log(rData);
            if (rData.result) {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "訊息";
              text += "完成";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => {
                self.F201_SearchGrid2("VirtualAssets");
                self.Alert.show = false;
                self.VirtualAssetsModal.show = false;
              };
            } else {
              self.Alert.enableClose = false;
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              text += "失敗";
              self.Alert.txt.push(text);
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
            }
          });
          break;
      }
    },
    //第三頁各財產刪除
    DetailModalItemBtnDelete: function () {
      const self = this;
      switch (self.DetailModal.MenuIndex) {
        case 0:
          //土地
          self.LandModal.modifiedType = "D";
          break;
        case 1:
          //建物
          self.BuildingModal.modifiedType = "D";
          break;
        case 2:
          //船舶
          self.VesselModal.modifiedType = "D";
          break;
        case 3:
          //汽車
          self.VehicleModal.modifiedType = "D";
          break;
        case 4:
          //航空器
          self.AircraftModal.modifiedType = "D";
          break;
        case 5:
          //航空器
          self.CurrencyModal.modifiedType = "D";
          break;
        case 6:
          //存款
          self.DepositModal.modifiedType = "D";
          break;
        case 7:
          //有價證券(股票)
          self.StockModal.modifiedType = "D";
          break;
        case 8:
          //有價證券(票券，債券，其他有價證券)
          self.BondValuePaperModal.modifiedType = "D";
          break;
        case 9:
          //有價證券(基金受益憑證)
          self.FundModal.modifiedType = "D";
          break;
        case 10:
          //其他財產
          self.OtherPropertyModal.modifiedType = "D";
          break;
        case 11:
          //保險
          self.InsuranceModal.modifiedType = "D";
          break;
        case 12:
          //債權
          self.ClaimModal.modifiedType = "D";
          break;
        case 13:
          //債務
          self.DebtModal.modifiedType = "D";
          break;
        case 14:
          //事業投資
          self.InvestmentModal.modifiedType = "D";
          break;
        case 16:
          //虛擬資產
          self.VirtualAssetsModal.modifiedType = "D";
          break;
      }

      self.DetailModalItemBtnSave();
    },
    caculateCurrency: function () {
      const self = this;
      self.CurrencyModal.form.twdSum =
        self.CurrencyModal.form.foreignSum == "" ||
          self.CurrencyModal.form.excRate == ""
          ? ""
          : String(
            parseFloat(self.CurrencyModal.form.foreignSum) *
            parseFloat(self.CurrencyModal.form.excRate)
          );
    },
    caculate: function () {
      const self = this;
      self.DepositModal.form.twdSum =
        self.DepositModal.form.foreignSum == "" ||
          self.DepositModal.form.excRate == ""
          ? ""
          : String(
            parseFloat(self.DepositModal.form.foreignSum) *
            parseFloat(self.DepositModal.form.excRate)
          );
    },
    caculateStockBond1: function () {
      const self = this;
      self.StockModal.form.twdSum =
        self.StockModal.form.share == "" ||
          self.StockModal.form.parValue == "" ||
          self.StockModal.form.excRate == ""
          ? ""
          : String(
            parseFloat(self.StockModal.form.share) *
            parseFloat(self.StockModal.form.parValue) *
            parseFloat(self.StockModal.form.excRate)
          );
    },
    //第三頁各財產重填
    DetailModalItemBtnClear: function () {
      const self = this;
      switch (self.DetailModal.MenuIndex) {
        case 0:
          //土地
          self.LandModal.form = {
            address: "",
            areaSystem: "",
            rights1: "",
            rights2: "",
            ownerIdn: "",
            owner: "",
            enterDate: "",
            enterReason: "",
            enterReasonText: "",
            price: "",
          };
          break;
        case 1:
          //建物
          self.BuildingModal.form = {
            address: "",
            regNo: "",
            areaSystem: "",
            rights1: "",
            rights2: "",
            ownerIdn: "",
            owner: "",
            attachBuildingAreaSystem: "",
            publicAreaSystem: "",
            enterDate: "",
            enterReason: "",
            enterReasonText: "",
            price: "",
          };
          break;
        case 2:
          //船舶
          self.VesselModal.form = {
            vesselType: "",
            vesselTypeText: "",
            ton: "",
            portReg: "",
            ownerIdn: "",
            owner: "",
            enterDate: "",
            enterReason: "",
            enterReasonText: "",
            price: "",
          };
          break;
        case 3:
          //汽車
          self.VehicleModal.form = {
            vehicleType: "",
            vehicleTypeText: "",
            volume: "",
            islicenseNo: "01",
            licenseNo: "",
            ownerIdn: "",
            owner: "",
            brand: "",
            enterDate: "",
            enterReason: "",
            enterReasonText: "",
            price: "",
          };
          break;
        case 4:
          //航空器
          self.AircraftModal.form = {
            aircraftType: "",
            factoryName: "",
            nationNumber: "",
            ownerIdn: "",
            owner: "",
            enterDate: "",
            enterReason: "",
            enterReasonText: "",
            price: "",
          };
          break;
        case 5:
          //現金
          self.CurrencyModal.form = {
            foreignSum: "",
            currency: "",
            excRate: "",
            twdSum: "",
            ownerIdn: "",
            owner: "",
          };
          break;
        case 6:
          //存款
          self.DepositModal.form = {
            category: "1",
            depositType: "",
            depositTypeText: "",
            institution: "",
            foreignSum: "",
            currency: "",
            excRate: "",
            twdSum: "",
            ownerIdn: "",
            owner: "",
          };
          break;
        case 7:
          //有價證券(股票)
          self.StockModal.form = {
            ownerIdn: "",
            stockCode: "",
            stockName: "",
            share: "",
            parValue: "",
            currency: "",
            excRate: "",
            twdSum: "",
          };
          break;
        case 8:
          //有價證券(票券，債券，其他有價證券)
          self.BondValuePaperModal.form = {
            ownerIdn: "",
            owner: "",
            stockCode: "",
            stockName: "",
            share: "",
            parValue: "",
            currency: "",
            excRate: "",
            institution: "",
            twdSum: "",
          };
          break;
        case 9:
          //有價證券(基金受益憑證)
          self.FundModal.form = {
            ownerIdn: "",
            stockCode: "",
            stockName: "",
            share: "",
            parValue: "",
            currency: "",
            excRate: "",
            institution: "",
            twdSum: "",
          };
          break;
        case 10:
          //其他財產
          self.OtherPropertyModal.form = {
            otherPropertiesType: "",
            ownerIdn: "",
            otherQuantity: "",
            price: "",
          };
          break;
        case 11:
          //保險
          self.InsuranceModal.form = {
            companyName: "",
            companyNameText: "",
            insuranceName: "",
            ownerIdn: "",
            remark: "",
          };

          break;
        case 12:
          //債權
          self.ClaimModal.form = {
            claimsType: "",
            ownerIdn: "",
            debtorName: "",
            debtorAddr: "",
            twdSum: "",
            enterDate: "",
            enterReason: "",
          };
          break;
        case 13:
          //債務
          self.DebtModal.form = {
            debtType: "",
            debtTypeText: "",
            claimsName: "",
            claimsAddr: "",
            ownerIdn: "",
            twdSum: "",
            enterDate: "",
            enterReason: "",
          };

          break;
        case 14:
          //事業投資
          self.InvestmentModal.form = {
            ownerIdn: "",
            companyName: "",
            companyAddress: "",
            priceTotal: "",
            enterDate: "",
            enterReason: "",
          };
          break;
        // case 15:
        //   //備註
        //   self.RemarkModal.show = true;
        //   break;
        case 16:
          //虛擬資產
          self.VirtualAssetsModal.form = {
            virtualAssetName: "",
            owners: "",
            amount: "",
            amountUnit: "顆",
            institution: "",
            account: "",
            enterReason: "",
            twdSum: "",
          }
      }
    },
    //A101明細
    btnA101Detail: function (data) {
      const self = this;
      self.A101DetailModal.form = {
        //取得Radmin_Rel內
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        idn: "",
        name: "",
        birthday: "",
        title: "",
        rank: "",
        tel: "",
        email: "",
        arriveDate: "",
        leaveDate: "",
        //現職狀況
        leave: "",
        //應申報身分資格
        status: "",
        //備註
        leave_Reason: "",
      };
      self.A101DetailModal.PreData = data;
      self.getA101DetailData(data);

      self.A101DetailModal.modifyType = "U";
      self.A101DetailModal.title = "A101申報人基本資料維護-明細";
      self.A101DetailModal.show = true;
    },
    //A101明細 API
    getA101DetailData: function (data) {
      const self = this;
      A101_DetailInit({ idn: data.idn, goV_CODE: data.goV_CODE }).then(
        (rData) => {
          if (rData.result) {
            self.A101DetailModal.grid = rData.returnObject;
            self.A101DetailModal.form = {
              //取得Radmin_Rel內
              govCode1: self.A101DetailModal.grid.r_GovCodeStr.split(",")[0],
              govCode2: self.A101DetailModal.grid.r_GovCodeStr.split(",")[1],
              govCode3: self.A101DetailModal.grid.r_GovCodeStr.split(",")[2],
              govCode4: self.A101DetailModal.grid.r_GovCodeStr.split(",")[3],
              jobGovCode1:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[0],
              jobGovCode2:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[1],
              jobGovCode3:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[2],
              jobGovCode4:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[3],
              idn: self.A101DetailModal.grid.idn,
              name: self.A101DetailModal.grid.name,
              birthday: self.A101DetailModal.grid.birthday,
              title: self.A101DetailModal.grid.title,
              rank: self.A101DetailModal.grid.rank,
              tel: self.A101DetailModal.grid.tel,
              email: self.A101DetailModal.grid.email,
              arriveDate: self.A101DetailModal.grid.arriveDate,
              leaveDate: self.A101DetailModal.grid.leaveDate,
              //現職狀況
              leave: self.A101DetailModal.grid.leave,
              //應申報身分資格
              status: self.A101DetailModal.grid.status,
              //備註
              leave_Reason: self.A101DetailModal.grid.leaveReason,
            };
          } else {
            self.A101DetailModal.show = false;

            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = [
              "未取得資料，請至A101確認此[身分證統一編號][受理申報機關]是否有資料",
            ];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
          self.A101DetailModalInit();
        }
      );
    },
    A101DetailModalInit: function () {
      const self = this;
      self.modalGetA101SearchGovCode1();
      self.modalGetA101SearchGovCode2();
      self.modalGetA101SearchGovCode3();
      self.modalGetA101SearchGovCode4();
      self.modalGetA101OnDeclare();
      self.modalGetA101OnJob();
    },
    //A101明細取得服務機關第一層類別 DetailModal
    modalGetA101SearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.A101DetailModal.dropDownList.govCode1s = rData.returnObject;
        self.A101DetailModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //A101明細取得服務機關第二層類別 DetailModal
    modalGetA101SearchGovCode2: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode1 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode1,
          LAYER_NUM: "2",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode2s = rData.returnObject;
          self.A101DetailModal.form.govCode2 =
            self.A101DetailModal.form.govCode2;
        });
      }
      if (self.A101DetailModal.form.jobGovCode1 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode1,
          LAYER_NUM: "2",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode2s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode2 =
            self.A101DetailModal.form.jobGovCode2;
        });
      }
    },
    //A101明細取得服務機關第三層類別 DetailModal
    modalGetA101SearchGovCode3: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode2 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode2,
          LAYER_NUM: "3",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode3s = rData.returnObject;
          self.A101DetailModal.form.govCode3 =
            self.A101DetailModal.form.govCode3;
        });
      }
      if (self.A101DetailModal.form.jobGovCode2 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode2,
          LAYER_NUM: "3",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode3s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode3 =
            self.A101DetailModal.form.jobGovCode3;
        });
      }
    },
    //A101明細取得服務機關第四層類別 DetailModal
    modalGetA101SearchGovCode4: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode3 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode3,
          LAYER_NUM: "4",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode4s = rData.returnObject;
          self.A101DetailModal.form.govCode4 =
            self.A101DetailModal.form.govCode4;
        });
      }
      if (self.A101DetailModal.form.jobGovCode3 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode3,
          LAYER_NUM: "4",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode4s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode4 =
            self.A101DetailModal.form.jobGovCode4;
        });
      }
    },
    //A101取得申報身分資格 DetailModal
    modalGetA101OnDeclare: function () {
      const self = this;
      SearchGridOnDeclare({}).then((rData) => {
        self.A101DetailModal.dropDownList.OnDeclare = [
          { mcode: "", mvalue: "" },
        ].concat(rData.returnObject);
      });
    },
    //A101取得在職狀態 GovCodeModal
    modalGetA101OnJob: function () {
      const self = this;
      SearchGridOnJob({}).then((rData) => {
        self.A101DetailModal.dropDownList.onJobs = [
          { value: "", text: "" },
        ].concat(rData.returnObject);
      });
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (!isNaN(parseInt(newValue)) && newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (!isNaN(parseInt(newValue)) && newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "DetailModal.currentpage": function (newValue, oldValue) {
      if (!isNaN(parseInt(newValue)) && newValue != oldValue) {
        var tableName = "";
        var self = this;
        switch (self.DetailModal.MenuIndex) {
          case 0:
            //土地
            tableName = "Land";
            break;
          case 1:
            //建物
            tableName = "Building";
            break;
          case 2:
            //船舶
            tableName = "Vessel";
            break;
          case 3:
            //汽車
            tableName = "Vehicle";
            break;
          case 4:
            //航空器
            tableName = "Aircraft";
            break;
          case 5:
            //現金
            tableName = "FCurrency";
            break;
          case 6:
            //存款
            tableName = "Deposit";
            break;
          case 7:
            //有價證券(股票)
            tableName = "StocknBond_1";
            break;
          case 8:
            //有價證券(票券，債券，其他有價證券)
            tableName = "StocknBond_2";
            break;
          case 9:
            //有價證券(基金受益憑證)
            tableName = "StocknBond_3";
            break;
          case 10:
            //其他財產
            tableName = "Misc";
            break;
          case 11:
            //保險
            tableName = "Insurance";
            break;
          case 12:
            //債權
            tableName = "Credit";
            break;
          case 13:
            //債務
            tableName = "Debit";
            break;
          case 14:
            //事業投資
            tableName = "Investment";
            break;
          // case 15:
          //   //備註
          //   break;
          case 16:
            tableName = "VirtualAssets";
            break;
        }
        this.F201_SearchGrid2(tableName);
      }
    },
    "DetailModal.pagesize": function (newValue, oldValue) {
      if (!isNaN(parseInt(newValue)) && newValue != oldValue) {
        var tableName = "";
        var self = this;
        switch (self.DetailModal.MenuIndex) {
          case 0:
            //土地
            tableName = "Land";
            break;
          case 1:
            //建物
            tableName = "Building";
            break;
          case 2:
            //船舶
            tableName = "Vessel";
            break;
          case 3:
            //汽車
            tableName = "Vehicle";
            break;
          case 4:
            //航空器
            tableName = "Aircraft";
            break;
          // case 5:
          //   //現金
          //   break;
          case 6:
            //存款
            tableName = "Deposit";
            break;
          case 7:
            //有價證券(股票)
            tableName = "StocknBond_1";
            break;
          case 8:
            //有價證券(票券，債券，其他有價證券)
            tableName = "StocknBond_2";
            break;
          case 9:
            //有價證券(基金受益憑證)
            tableName = "StocknBond_3";
            break;
          case 10:
            //其他財產
            tableName = "Misc";
            break;
          case 11:
            //保險
            tableName = "Insurance";
            break;
          case 12:
            //債權
            tableName = "Credit";
            break;
          case 13:
            //債務
            tableName = "Debit";
            break;
          case 14:
            //事業投資
            tableName = "Investment";
            break;
          // case 15:
          //   //備註
          //   break;
          case 16:
            tableName = "VirtualAssets";
            break;
        }
        this.F201_SearchGrid2(tableName);
      }
    },
    // "BondValuePaperModal.form.currency": function (newValue, oldValue) {
    //   if (newValue == "1" || newValue == "42") {
    //     this.BondValuePaperModal.form.excRate = "1";
    //   } else {
    //     this.BondValuePaperModal.form.excRate = "";
    //   }
    // },
    // "FundModal.form.currency": function (newValue, oldValue) {
    //   if (newValue == "1" || newValue == "42") {
    //     this.FundModal.form.excRate = "1";
    //   } else {
    //     this.FundModal.form.excRate = "";
    //   }
    // },
  },
  created() {
    const self = this;
    //教育部的部分新系統後台請維持先前作法，以系統寫死六組之方式
    if (
      self.loginInfo &&
      self.loginInfo.govCodeStr.split(",")[0] === "309000000E"
    ) {
      switch (self.loginInfo.govCode) {
        case "309000000E":
        case "309000100E":
        case "A09000000E":
        case "A09010000E":
        case "A09020000E":
        case "309130000E":
        case "309190000E":
          break;
        default:
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.$router.go(-1);
          };
          break;
      }
    }
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
    self.JobGovCodeInit(self.form);
    self.getSearchJobGovCode1();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />

<style scoped>
@media (min-width: 1000px) {
  .col-3 {
    width: 25% !important;
  }
}
</style>
